const webtraderLocalization = require('./localization');
webtraderLocalization.configure(jQuery, window.translations);

const SUPPORT_HIDDEN_STORAGE_KEY = 'support_hidden_state';

function hasUnreadSupportMessages() {
    let hasUnread = false;

    $('.j-open_support span, .j-open_support_header span').each(function() {
        if ((parseInt($(this).text(), 10) || 0) > 0) {
            hasUnread = true;
            return false;
        }
    });

    return hasUnread;
}

function persistSupportHiddenState(isHidden) {
    try {
        window.localStorage.setItem(SUPPORT_HIDDEN_STORAGE_KEY, isHidden ? '1' : '0');
    } catch (e) {}
}

function readSupportHiddenState() {
    try {
        const raw = window.localStorage.getItem(SUPPORT_HIDDEN_STORAGE_KEY);

        if (raw === null) {
            return null;
        }

        return raw === '1';
    } catch (e) {
        return null;
    }
}

function setSupportHiddenState(isHidden, shouldPersist = true) {
    const support = $('.j-support');

    if (!support.length) {
        return;
    }

    support.toggleClass('m-hidden', isHidden);

    if (shouldPersist) {
        persistSupportHiddenState(isHidden);
    }

    syncSupportToggleState();
}

function renderSupportDateGroups() {
    const chat = $('.support__chat');

    if (!chat.length) {
        return;
    }

    chat.find('.support__date-divider').remove();

    let lastDate = null;

    chat.find('.b-message').each(function() {
        const message = $(this);
        const dateKey = message.attr('data-message-date');

        if (!dateKey) {
            return;
        }

        if (dateKey !== lastDate) {
            const dateLabel = message.attr('data-message-date-label') || dateKey;
            const divider = $('<div class="support__date-divider"><span></span></div>');
            divider.find('span').text(dateLabel);
            message.before(divider);
            lastDate = dateKey;
        }
    });
}

function markSupportRead() {
    const token = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/markSupportRead',
        data: { '_token': token },
        dataType: 'json'
    });
}

let supportSoundUnlocked = false;
document.addEventListener('click', function() { supportSoundUnlocked = true; });
document.addEventListener('keydown', function() { supportSoundUnlocked = true; });

function playSupportNotificationSound() {
    if (!window.SUPPORT_SOUND_ENABLED || !supportSoundUnlocked) return;
    try {
        var audio = new Audio('/sounds/notification.mp3');
        audio.play();
    } catch(e) {}
}

function showSupportPopup(popupHtml) {
    if (!popupHtml) {
        return;
    }

    const $growl = $.bootstrapGrowl(popupHtml, {
        type: 'info',
        delay: 40000,
        allow_dismiss: false
    });

    const $closeButton = $('<button class="close support-growl-close" type="button"><span aria-hidden="true">&times;</span><span class="sr-only"></span></button>');
    $closeButton.attr('aria-label', window.translations.close);
    $closeButton.find('.sr-only').text(window.translations.close);

    $growl.append($closeButton);

    $growl.on('click', '.support-growl-close', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $growl.stop(true).fadeOut(200, function () { $(this).alert('close'); });
    });

    $growl.addClass('support-growl').on('click', function () {
        $('.j-open_support').first().trigger('click');
        $(this).stop(true).fadeOut(200, function () { $(this).alert('close'); });
    });
}

window.updateChats = function updateChats(response) {

    var token = $('meta[name="csrf-token"]').attr('content'),
        data = { '_token': token, 'data': response };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/updateChats',
        data: data,
        dataType: 'json',
        success: function(msg) {

            if(msg['success'] == true) {

                playSupportNotificationSound();

                const support = $('.j-support');

                if(support.hasClass('m-active')) {
                    support.find('.support__chat').append(msg['message']);
                    renderSupportDateGroups();
                    $('.support__chat').scrollTop($('.support__chat')[0].scrollHeight);
                    markSupportRead();
                } else {

                    const supportCounter = $('.j-open_support span, .j-open_support_header span');

                    if(supportCounter.length > 0) {
                        supportCounter.each(function() {
                            $(this).text((parseInt($(this).text(), 10) || 0) + 1);
                        });
                    } else {
                        $('.j-open_support, .j-open_support_header').append('<span>1</span>');
                    }

                    if (support.hasClass('m-hidden')) {
                        setSupportHiddenState(false);
                    }

                    showSupportPopup(msg['popup_html']);

                }

            }

        },
        error: function(data) {
            var errors = data.responseJSON;
            console.log(errors);
        }
    });

}

function syncSupportToggleState() {
    const support = $('.j-support');
    const toggle = $('.j-toggle_support_visibility');
    const isHidden = support.hasClass('m-hidden');
    const hasUnread = hasUnreadSupportMessages();

    toggle.toggleClass('m-collapsed', isHidden);
    toggle.attr('aria-expanded', !isHidden);
    toggle.attr('aria-disabled', hasUnread);
}

$('body').on('click', '.j-open_support', function() {

    setSupportHiddenState(false);
    $('.j-support').addClass('m-active');
    $('.j-open_support span, .j-open_support_header span').remove();
    syncSupportToggleState();

    var token = $('meta[name="csrf-token"]').attr('content'),
        data = { '_token': token};

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/getSupport',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {
                $('.j-support').find('.support__chat').html(msg['html']);
                renderSupportDateGroups();
                $('.j-support button.m-submit').attr("disabled", false);
                $('.support__chat').scrollTop($('.support__chat')[0].scrollHeight);
            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            var errors = data.responseJSON;
            $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
        }
    });

});

$('body').on('click', '.j-open_support_header', function(e) {
    e.preventDefault();
    const supportButton = $('.j-support').find('.j-open_support').first();

    if (supportButton.length > 0) {
        supportButton.trigger('click');
    }
});

$('body').on('click', '.j-toggle_support_visibility', function(e) {
    e.preventDefault();

    const support = $('.j-support');
    const isHidden = support.hasClass('m-hidden');

    if (hasUnreadSupportMessages()) {
        setSupportHiddenState(false);
        return;
    }

    if (!isHidden && support.hasClass('m-active')) {
        support.removeClass('m-active');
        support.find('.support__chat').html('<div class="b-loading m-small"></div>');
        support.find('button.m-submit').attr("disabled", true);
    }

    setSupportHiddenState(!isHidden);
});

const persistedSupportHiddenState = readSupportHiddenState();
const initialSupportHiddenState = hasUnreadSupportMessages()
    ? false
    : persistedSupportHiddenState === true;
setSupportHiddenState(initialSupportHiddenState, false);

(function () {
    if (!isMobileDevice()) return;
    if (!('IntersectionObserver' in window)) return;

    let supportAutoHiddenByScroll = false;

    const tradesSection = document.getElementById('trades');
    if (!tradesSection) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                if (hasUnreadSupportMessages()) return;
                if ($('.j-support').hasClass('m-hidden')) return;
                supportAutoHiddenByScroll = true;
                setSupportHiddenState(true, false);
            } else {
                if (!supportAutoHiddenByScroll) return;
                supportAutoHiddenByScroll = false;
                setSupportHiddenState(false, false);
            }
        });
    }, { threshold: 0.1 });

    observer.observe(tradesSection);
}());

window.addMarkerOnChart = function addMarkerOnChart(msg) {
    try {
        if (!window.tvWidget || !msg.trade || !msg.trade.time || !msg.trade.type) return;

        const chart = window.tvWidget.activeChart();

        if (!window.lastBarsData || !Array.isArray(window.lastBarsData)) {
            console.warn('No cached bars available for trade marker');
            return;
        }

        // ✅ Find nearest bar by time
        const targetBar = findNearestBar(window.lastBarsData, msg.trade.time);
        if (!targetBar) {
            console.warn('No nearby bar found for trade marker');
            return;
        }

        // ✅ Determine marker type ('open' or 'close')
        const markerType = msg.trade.is_close ? 'close' : 'open';

        // ✅ Draw the marker
        drawTradeMarkers(chart, targetBar, {
            side: msg.trade.type,
            type: markerType,
        });

    } catch (err) {
        console.warn('Failed to draw trade marker:', err);
    }
};

$('body').on('click', '.j-close_support', function() {
    $('.j-support').removeClass('m-active');
    $('.j-support').find('.support__chat').html('<div class="b-loading m-small"></div>');
    $('.j-support button.m-submit').attr("disabled", true);
});

$('body').on('click', '.j-upload_file', function(e) {
    e.preventDefault();
    $('#upload_files').click();
});

$('#upload_files').on('change', function() {
    const filesCount = this.files.length;
    const hasMessage = $('input[name="message"]').val().trim().length > 0;
    $('.support-send.m-submit').prop('disabled', !(filesCount > 0 || hasMessage));

    if (filesCount > 0) {
      $('.j-upload_file').html('<span>'+ filesCount +'</span>');
    }
});

function enableScroll() {

    const table = $('.table-responsive');

    if(table.length > 0) {
        if(table.width() < 960) {
            table.each(function() {
                new SimpleBar($(this)[0]);
            });
        }
    }

}

window.updateColor = function (current, currentPrice) {

    var currentClass = '';

    var currentText = parseFloat(current.text()),
        currentPrice = parseFloat(currentPrice);

    if(currentText > currentPrice) {
        currentClass = 'm-down';
    } else if(currentText < currentPrice) {
        currentClass = 'm-up';
    }

    current.addClass(currentClass);

    setTimeout(function () {
        current.removeClass(currentClass);
    }, 1000);

}

window.setPnl = function () {

    var arr = [];

    $('#open .j-trade > td > span.j-pnl').each(function() {
        arr.push($(this).text().replace(',', ''));
    });

    var sum = arr.reduce((pv,cv)=>{
        return pv + (parseFloat(cv)||0);
    }, 0);

    $('.j-open_pnl').text(sum.toFixed(2));
    updateOpenPnlPercent()

    return sum;

}

function parseStatNumber(value) {
    if (value === undefined || value === null) {
        return NaN;
    }

    let normalizedValue = String(value)
        .trim()
        .replace(/\s+/g, '')
        .replace(/,/g, '')
        .replace(/[^0-9.-]/g, '');

    if (!normalizedValue || normalizedValue === '-' || normalizedValue === '.' || normalizedValue === '-.') {
        return NaN;
    }

    return parseFloat(normalizedValue);
}

function formatTerminalAmount(value, decimals = 2) {
    let num = parseStatNumber(value);

    if (!Number.isFinite(num)) {
        num = 0;
    }

    return num.toFixed(decimals);
}

function formatTerminalPercent(value, decimals = 1) {
    return formatTerminalAmount(value, decimals);
}

window.updateOpenPnlPercent = function () {
    const percentEl = $('.j-p_open_pnl_percent');

    if (!percentEl.length) {
        return;
    }

    const balance = parseStatNumber($('.j-total_balance').first().text());

    let openPnlText = $('.j-open_pnl').first().text();
    if (!openPnlText) {
        openPnlText = $('.j-p_open_pnl').first().text();
    }

    const openPnl = parseStatNumber(openPnlText);

    if (!Number.isFinite(balance) || !Number.isFinite(openPnl) || balance === 0) {
        percentEl.removeClass('m-up m-down').text('(0.0%)');
        return;
    }

    const percent = (openPnl / balance) * 100;
    percentEl
        .removeClass('m-up m-down')
        .toggleClass('m-up', percent > 0)
        .toggleClass('m-down', percent < 0)
        .text(`(${percent.toFixed(1)}%)`);
};

window.setEquity = function (pnl = null) {

    if(!pnl) {
        var pnl = parseFloat($('.j-open_pnl').text());
    }

    const totalBalance = parseFloat($('.j-total_balance').text()),
        bonusFunds = parseFloat($('.j-bonus').text()),
        creditFunds = parseFloat($('.j-credit').text());

    var arr = [];

    $('#open .j-trade > td.j-commission').each(function() {
        arr.push($(this).text().replace(',', ''));
    });

    $('#pending .j-trade > td.j-commission').each(function() {
        arr.push($(this).text().replace(',', ''));
    });

    var commisions = arr.reduce((pv,cv)=>{
        return pv + (parseFloat(cv)||0);
    }, 0);

    $('.j-equity').text((totalBalance + bonusFunds + creditFunds + pnl).toFixed(2));

}

function fixSidebar() {

    var sidebarEl = $('.j-sidebar');

    if(sidebarEl.length > 0 && $(window).width() >= 1200) {

        $('.j-crypto__table').height('0').css('opacity', 0);

        var content = $('.j-content').height(),
            search = sidebarEl.find('.b-search').outerHeight(),
            cryptoTit = sidebarEl.find('.crypto__tit').outerHeight(),
            margins = parseFloat(sidebarEl.find('.b-search').css('margin-bottom')) * 2,
            paddings = parseFloat(sidebarEl.find('.b-crypto').css('padding')) * 2,
            tableHeight = content - search - cryptoTit - margins - paddings;

        $('.j-crypto__table').height(tableHeight).css('opacity', 1);

    }

}

function getRestrictedOrderLimit() {
    var tradingType = parseInt($('[name="trading_type"]').val(), 10);
    if (tradingType !== 1) {
        return 0;
    }

    var limit = parseFloat($('[name="restricted_order_amount"]').val());

    if (isNaN(limit) || limit <= 0) {
        return 0;
    }

    return limit;
}

function applyRestrictedOrderLimit(freeMargin) {
    var limit = getRestrictedOrderLimit();

    if (limit > 0 && freeMargin > 0) {
        return Math.min(freeMargin, limit);
    }

    return freeMargin;
}

function getConfiguredMinTradeAmount() {
    var min = parseFloat($('[name="min_trade_amount"]').val());

    if (isNaN(min) || min <= 0) {
        return 0;
    }

    return min;
}

var skipMinAutofixOnSubmitClick = false;

function enforceTradeInputMinimums() {
    var minTradeAmount = getConfiguredMinTradeAmount();
    var usedMarginInput = $('[name="used_margin"]');
    var usedMargin = parseFloat(usedMarginInput.val());

    if (minTradeAmount > 0 && !isNaN(usedMargin) && usedMargin > 0 && usedMargin < minTradeAmount) {
        usedMarginInput.val(minTradeAmount.toFixed(2));
        handleCalculationTrigger({ target: { name: 'used_margin' } });
        return true;
    }

    return false;
}

function createTradeSlider(mode) {
    $('.j-trade_slider').each(function() {
        var self = $(this);

        if (self.hasClass('ui-slider')) {
            try {
                self.slider('destroy');
            } catch (e) {}
        }

        // ✅ Correct var declarations
        var min = Number(self.attr('data-min')),
            max = Number(self.attr('data-max')),
            step = Number(self.attr('data-step')),
            initialValue;

        if(!mode) {
            mode = self.attr('data-mode')
        }

        // ✅ Determine initial value and max depending on mode
        if (mode === 'currency') {
            var freeMarginRaw = parseFloat($('[name="free_margin"]').val());
            var freeMargin = isFinite(freeMarginRaw) ? freeMarginRaw : 0;
            if (freeMargin <= 0) {
                var headerFreeMargin = parseFloat(String($('.j-free_margin').first().text() || '').replace(',', ''));
                if (isFinite(headerFreeMargin) && headerFreeMargin > 0) {
                    freeMargin = headerFreeMargin;
                }
            }
            var budget = applyRestrictedOrderLimit(freeMargin);
            var entryPrice = parseFloat($('[name="bid_price"]').val()) || 0;
            var leverage = parseFloat($('[name="leverage"]').val() || 1);
            var commissionRate = parseFloat($('[name="commission"]').val()) || 0;
            var commission = budget * commissionRate / 100;

            if (entryPrice > 0) {
                max = ((budget - commission) * leverage) / entryPrice;
            }

            initialValue = parseFloat($('[name="quantity"]').val()) || 0;
        } else {
            var minTradeAmount = getConfiguredMinTradeAmount();

            if (minTradeAmount > 0) {
                min = minTradeAmount;
            }

            max = applyRestrictedOrderLimit(parseFloat($('[name="free_margin"]').val()) || 0);
            initialValue = parseFloat($('[name="used_margin"]').val()) || min;
        }

        if (max < 0) {
            max = 0;
        }

        if (min > max) {
            min = max;
        }

        if (!isFinite(min)) {
            min = 0;
        }
        if (!isFinite(max)) {
            max = min;
        }
        if (!isFinite(step) || step <= 0) {
            step = 0.01;
        }
        if (!isFinite(initialValue)) {
            initialValue = min;
        }
        if (initialValue < min) {
            initialValue = min;
        } else if (initialValue > max) {
            initialValue = max;
        }

        // ✅ Initialize slider
        self.slider({
            range: 'min',
            min: min,
            max: max,
            step: step,
            value: initialValue,
            start: function(event, ui) {
                ensureSliderTooltip(ui.handle);
                var percent = max > 0 ? Math.round((parseFloat(ui.value) / max) * 100) : 0;
                $(ui.handle).find('.slider-tooltip').text(percent + '%');
            },
            slide: function(event, ui) {
                ensureSliderTooltip(ui.handle);
                var val = parseFloat(ui.value);
                var percent = max > 0 ? Math.round((val / max) * 100) : 0;
                $(ui.handle).find('.slider-tooltip').text(percent + '%');

                // Enable/disable submit button
                $('#trade button[type="submit"]').attr('disabled', val <= 0);

                if (mode === 'currency') {
                    $('[name="quantity"]').val(val);
                    calc();
                    updateTakeProfitHint();
                    sliderDots(self, val, max);
                } else {
                    $('[name="used_margin"]').val(val);
                    handleCalculationTrigger({ target: { name: 'used_margin' } });
                    sliderDots(self, val, max);
                }
            }
        });

        ensureSliderTooltip(self.find('.ui-slider-handle').first());
    });
}

function ensureSliderTooltip(handle) {
    var sliderHandle = $(handle);

    if (!sliderHandle.length || sliderHandle.find('.slider-tooltip').length) {
        return;
    }

    sliderHandle.append('<div class="slider-tooltip">0%</div>');
}

function createCloseTradeSlider() {

    $('.j-close_trade_slider').each(function() {

        var self = $(this),
            form = $(this).closest('form'),
            value = Number(self.attr('data-value')),
            min = Number(self.attr('data-min')),
            max = Number(self.attr('data-max'));
            step = Number(self.attr('data-step'));

        var slider = self.slider({
            create: function() {},
            slide: function(event, ui) {

                var percent = ui.value,
                    pnlAll = form.find('[name="pnl_all"]').val(),
                    quantity = self.attr('data-quantity');

                form.find('.j-pnl').text((pnlAll * (percent / 100)).toFixed(2));
                form.find('.j-amount').text((quantity * (percent / 100)).toFixed(2));
                form.find('[name="amount"]').val((quantity * (percent / 100)).toFixed(2));

                sliderDots(self, percent, max);

            },
            range: 'min',
            min: min,
            max: max,
            step: step,
            value: value,
        });

    });

}

window.createCloseTradeSlider = createCloseTradeSlider

function resetTradeForm() {
    var defaultValue = '';

    $('#trade').find('[name="take_profit"], [name="stop_loss"]').val('');
    $('#trade').find('[name="quantity"], [name="used_margin"]').val(defaultValue);
    // $('[name="take_profit_checkbox"], [name="stop_loss_checkbox"]').prop('checked', false);
    $('.j-trade_slider').find('.label-slider').removeClass('m-active');
    $('.j-required_margin').text('');
    calc(0);
    updateTakeProfitHint();
    updateStopLossHint();
    createTradeSlider();
}

$('body').on('change', '[name="order_type"]', function() {
    $('.j-price_input').toggleClass('m-hidden');
});

$('body').on('change', '[name="quantity_type"]', function() {
    var quantityType = $(this).val();
    var currentQuantity = parseFloat($('[name="quantity"]').val()) || 0;
    var entryPrice = parseFloat($('[name="bid_price"]').val());
    var leverage = parseFloat($('[name="leverage"]').val() || 1);

    if (quantityType === 'fiat' && currentQuantity > 0 && entryPrice > 0) {
        // Convert base currency quantity to USD equivalent
        var usdValue = (currentQuantity * entryPrice) / leverage;
        $('[name="quantity"]').val(usdValue.toFixed(2));
    } else if (quantityType === 'currency' && currentQuantity > 0 && entryPrice > 0) {
        // Convert USD back to base currency
        var baseValue = (currentQuantity * leverage) / entryPrice;
        $('[name="quantity"]').val(baseValue.toFixed(8));
    }

    // Trigger calculation with the new value
    handleCalculationTrigger({target: {name: "quantity"}});
});

$('body').on('change', '.m-quantity', function () {

    const mode = $(this).val(); // "currency" or "usd"
    const defaultValue = '';

    if (mode === 'currency') {
        $('.j-quantity').show().val(defaultValue);
        $('.j-used_margin').hide().val(defaultValue);
    } else {
        $('.j-quantity').hide().val(defaultValue);
        $('.j-used_margin').show().val(defaultValue);
    }

    // Clear calculated fields if needed
    $('.j-required_margin').text('');
    $('.j-amount').text('');
    $('.j-commision').text('');
    $('[name="used_funds"]').val('');
    $('#trade button[type="submit"]').attr('disabled', true);

    // Recreate slider for the new mode
    createTradeSlider(mode);

    // Trigger recalculation with the active input
    handleCalculationTrigger({ target: { name: mode === 'currency' ? 'quantity' : 'used_margin' } });

});


$('body').on('keyup', '[name="quantity"], [name="bid_price"], [name="used_margin"]', handleCalculationTrigger);
$('body').on('keyup change', '[name="take_profit"], [name="exit_tp"]', updateTakeProfitHint);
$('body').on('keyup change', '[name="stop_loss"], [name="exit_sl"]', updateStopLossHint);
$('body').on('change', '[name="type_id"]', function() {
    updateTakeProfitHint();
    updateStopLossHint();
});
$('body').on('mousedown', '#trade button[type="submit"]', function() {
    skipMinAutofixOnSubmitClick = true;
    setTimeout(function() {
        skipMinAutofixOnSubmitClick = false;
    }, 250);
});
$('body').on('blur change', '[name="used_margin"]', function() {
    if (skipMinAutofixOnSubmitClick) {
        return;
    }

    enforceTradeInputMinimums();
});

function handleCalculationTrigger(e) {

    var mode = $('.m-quantity').val(); // currency or usd
    var quantity, sliderValue;

    if (mode === 'fiat') {

        var usedMargin = parseFloat($('[name="used_margin"]').val()) || 0;
        var entryPrice = parseFloat($('[name="bid_price"]').val()) || 0;
        var commissionRate = parseFloat($('[name="commission"]').val()) || 0;
        var leverage = parseFloat($('[name="leverage"]').val() || 1);

        var countMargin = usedMargin / (1 + commissionRate / 100);
            quantity = parseFloat(((countMargin * leverage) / entryPrice).toFixed(6));

        $('[name="quantity"]').val(quantity);

        sliderValue = usedMargin; // slider works with used margin in USD mode

    } else {
        quantity = parseFloat($('[name="quantity"]').val()) || 0;
        sliderValue = quantity;  // slider works with quantity in currency mode
    }

    var data = calc();

    if (e.target.name === "quantity" || e.target.name === "used_margin") {
        sliderDots($('.j-trade_slider'), data.requiredMargin, data.budget);
    }

    $('.j-trade_slider').slider('value', sliderValue);
    updateTakeProfitHint();
    updateStopLossHint();

}

function calc() {

    $('.bootstrap-growl').remove();

    var quantity = parseFloat($('[name="quantity"]').val());
    if (isNaN(quantity)) {
        quantity = 0;
        $('#trade button[type="submit"]').attr('disabled', true);
    }

    var budget = applyRestrictedOrderLimit(parseFloat($('[name="free_margin"]').val()) || 0),
        leverage = parseFloat($('[name="leverage"]').val() || 1),
        entryPrice = parseFloat($('[name="bid_price"]').val()),
        payout = parseFloat($('[name="payout"]').val());

    var countMargin = parseFloat(((quantity * entryPrice) / leverage).toFixed(2)),
        commission = parseFloat((countMargin * parseFloat($('[name="commission"]').val()) / 100).toFixed(2)),
        requiredMargin = parseFloat((countMargin + commission).toFixed(2));

    const cryptoCurrency = $('.m-quantity option[value="currency"]').text().trim();
    const tradingCurrency = $('.m-quantity option[value="fiat"]').text().trim();
    const $submitBtn = $('#trade button[type="submit"]');
    const minTradeAmount = getConfiguredMinTradeAmount();
    const activeRequiredMargin = $('.m-quantity').val() === 'fiat'
        ? (parseFloat($('[name="used_margin"]').val()) || 0)
        : requiredMargin;

    let errorMessage = null;

    if (minTradeAmount > 0 && quantity !== 0 && activeRequiredMargin < minTradeAmount) {
        errorMessage = `Min stake - ${minTradeAmount.toFixed(2)} ${tradingCurrency}`;
    }

    if (errorMessage) {
        $.bootstrapGrowl(errorMessage, { delay: 3000 });
        $submitBtn.attr('disabled', true);
        return { requiredMargin: undefined, budget: undefined };
    }

    $submitBtn.attr('disabled', false);

    $('.j-amount').text(quantity);
    $('.j-required_margin').text(requiredMargin);
    $('[name="used_funds"]').val(requiredMargin);
    $('.j-commision').text(commission);

    if (payout) {
        var potentialProfit = parseFloat(((countMargin * payout) - countMargin).toFixed(2));
        $('.j-potential_profit').text(potentialProfit);
    }

    if (requiredMargin > budget) {
        $.bootstrapGrowl(window.translations.not_enough, { delay: 3000 });
        $('#trade button[type="submit"]').attr('disabled', true);
    } else {
        $('#trade button[type="submit"]').attr('disabled', quantity <= 0);
    }

    if ($('.m-quantity').val() === 'fiat') {
        requiredMargin = parseFloat($('[name="used_margin"]').val()) || 0;
        $('.j-required_margin').text(requiredMargin ? requiredMargin.toFixed(2) : '0');
    }

    return { "requiredMargin": requiredMargin, "budget": budget };

}

// The quote-change handler in layouts/app.blade.php runs outside this bundle.
window.handleCalculationTrigger = handleCalculationTrigger;

const ORDER_PREVIEW_LINE_COLORS = {
    take_profit: '#47B935',
    stop_loss: '#f23645',
};

window._orderPreviewLines = window._orderPreviewLines || {};

function clearOrderPreviewLines() {
    Object.keys(window._orderPreviewLines).forEach(function (fieldName) {
        try {
            window._orderPreviewLines[fieldName].remove();
        } catch (e) {}
    });
    window._orderPreviewLines = {};
}
window.clearOrderPreviewLines = clearOrderPreviewLines;

function computeOrderPreviewPrice($form, fieldName, exitFieldName) {
    const exitType = parseInt($form.find('[name="' + exitFieldName + '"]').val(), 10) || 0;
    const rawValue = parseFloat($form.find('[name="' + fieldName + '"]').val());

    if (!rawValue || rawValue <= 0) {
        return null;
    }

    if (exitType === 0) {
        return rawValue; // input already holds a price
    }

    // PNL mode: convert the target profit/loss amount back into a price
    const type = parseInt($form.find('[name="type_id"]:checked').val(), 10) || 0;
    const quantity = parseFloat($form.find('[name="quantity"]').val()) || 0;
    const entryPrice = parseFloat($form.find('[name="bid_price"]').val()) || 0;

    if (quantity <= 0 || entryPrice <= 0) {
        return null;
    }

    const pnl = fieldName === 'stop_loss' ? -Math.abs(rawValue) : rawValue;
    const priceDelta = pnl / quantity;

    return type === 0 ? entryPrice + priceDelta : entryPrice - priceDelta;
}

function setOrderPreviewLine(fieldName, price) {
    if (!window.tvWidget || typeof window.tvWidget.activeChart !== 'function') {
        return;
    }

    const existingLine = window._orderPreviewLines[fieldName];

    if (!price || !isFinite(price) || price <= 0) {
        if (existingLine) {
            try {
                existingLine.remove();
            } catch (e) {}
            delete window._orderPreviewLines[fieldName];
        }
        return;
    }

    let chart;
    try {
        chart = window.tvWidget.activeChart();
    } catch (e) {
        return;
    }

    const color = ORDER_PREVIEW_LINE_COLORS[fieldName];

    if (existingLine) {
        try {
            existingLine.setPrice(price);
            return;
        } catch (e) {
            delete window._orderPreviewLines[fieldName];
        }
    }

    try {
        window._orderPreviewLines[fieldName] = chart.createOrderLine()
            .setPrice(price)
            .setText('')
            .setLineColor(color)
            .setBodyBackgroundColor('rgba(0,0,0,0)')
            .setBodyBorderColor('rgba(0,0,0,0)')
            .setBodyTextColor('rgba(0,0,0,0)')
            .setQuantity('')
            .setLineStyle(2)
            .setLineWidth(1)
            .setEditable(false)
            .setCancellable(false);
    } catch (e) {
        console.warn('Failed to draw ' + fieldName + ' preview line', e);
    }
}

function updateOrderPreviewLine(fieldName, checkboxName, exitFieldName) {
    const $form = $('#trade');
    const isEnabled = $form.find('[name="' + checkboxName + '"]').is(':checked');
    const price = isEnabled ? computeOrderPreviewPrice($form, fieldName, exitFieldName) : null;

    setOrderPreviewLine(fieldName, price);
}

function updateTakeProfitHint() {
    const $form = $('#trade');
    const $valueEl = $form.find('.j-tp_profit_value');

    updateOrderPreviewLine('take_profit', 'take_profit_checkbox', 'exit_tp');

    if ($valueEl.length === 0) {
        return;
    }

    const symbol = $valueEl.data('symbol') || '';
    const type = parseInt($form.find('[name="type_id"]:checked').val(), 10) || 0;
    const exitType = parseInt($form.find('[name="exit_tp"]').val(), 10) || 0;
    const takeProfit = parseFloat($form.find('[name="take_profit"]').val()) || 0;

    let pnl = 0;

    if (exitType === 1) {
        pnl = takeProfit;
    } else {
        const quantity = parseFloat($form.find('[name="quantity"]').val()) || 0;
        const entryPrice = parseFloat($form.find('[name="bid_price"]').val()) || 0;

        if (quantity > 0 && entryPrice > 0 && takeProfit > 0) {
            if (type === 0) {
                pnl = (takeProfit - entryPrice) * quantity;
            } else {
                pnl = (entryPrice - takeProfit) * quantity;
            }
        }
    }

    if (pnl < 0 || isNaN(pnl)) {
        pnl = 0;
    }

    $valueEl.text(symbol + pnl.toFixed(2));
}

function updateStopLossHint() {
    const $form = $('#trade');
    const $valueEl = $form.find('.j-sl_loss_value');

    updateOrderPreviewLine('stop_loss', 'stop_loss_checkbox', 'exit_sl');

    if ($valueEl.length === 0) {
        return;
    }

    const symbol = $valueEl.data('symbol') || '';
    const type = parseInt($form.find('[name="type_id"]:checked').val(), 10) || 0;
    const exitType = parseInt($form.find('[name="exit_sl"]').val(), 10) || 0;
    const stopLoss = parseFloat($form.find('[name="stop_loss"]').val()) || 0;

    let pnl = 0;

    if (exitType === 1) {
        pnl = -Math.abs(stopLoss);
    } else {
        const quantity = parseFloat($form.find('[name="quantity"]').val()) || 0;
        const entryPrice = parseFloat($form.find('[name="bid_price"]').val()) || 0;

        if (quantity > 0 && entryPrice > 0 && stopLoss > 0) {
            if (type === 0) {
                pnl = (stopLoss - entryPrice) * quantity;
            } else {
                pnl = (entryPrice - stopLoss) * quantity;
            }
        }
    }

    let loss = 0;
    if (!isNaN(pnl) && pnl < 0) {
        loss = Math.abs(pnl);
    }

    $valueEl.text(symbol + loss.toFixed(2));
}

function sliderDots(slider, total, max) {

    if(total >= max * 0.25) {
        slider.find('.label-slider:nth-child(2)').addClass('m-active');
    }

    if(total >= max * 0.50) {
        slider.find('.label-slider:nth-child(3)').addClass('m-active');
    }

    if(total >= max * 0.75) {
        slider.find('.label-slider:nth-child(4)').addClass('m-active');
    }

    if(total < max * 0.25) {
        slider.find('.label-slider:nth-child(2)').removeClass('m-active');
    }

    if(total < max * 0.50) {
        slider.find('.label-slider:nth-child(3)').removeClass('m-active');
    }

    if(total < max * 0.75) {
        slider.find('.label-slider:nth-child(4)').removeClass('m-active');
    }

}

$('body').on('change', '[name="account"]', function() {

    var token = $('meta[name="csrf-token"]').attr('content'),
        data = { '_token': token, 'account_id': $(this).val() };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/changeAccount',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {
                // Full reload on every account switch, statistics page included.
                // That page used to AJAX-refetch its widgets here (no reload),
                // but switching account rewrites the balance panel and reflows
                // the page while the widget charts are calling ApexCharts
                // render() concurrently, so the topmost chart (Total PNL) gets
                // measured mid-reflow and renders blank or keeps the previous
                // account's data (task #714). A reload lets the layout settle
                // once before the charts draw — which is why a manual refresh
                // always looks correct.
                window.location.reload();
            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
        }
    });

});

$('body').on('blur', '.js-leverage', function() {

    const $input = $(this);
    let leverage = parseInt(String($input.val() ?? '').trim(), 10);
    const initialLeverage = String(this.defaultValue ?? '').trim();
    const accountId = $input.data('account-id');
    const maxLeverage = parseInt($input.data('max-leverage'), 10);

    if (!isNaN(maxLeverage) && maxLeverage > 0 && leverage > maxLeverage) {
        leverage = maxLeverage;
        $input.val(maxLeverage);
        $.bootstrapGrowl(window.translations.max_leverage.replace(':leverage', String(maxLeverage)), {delay: 3000, type: 'warning'});
    }

    if (String(leverage) === initialLeverage) {
        return;
    }

    $.ajax({
        url: '/update-trading-leverage',
        method: 'POST',
        data: {
            _token: $('meta[name="csrf-token"]').attr('content'),
            leverage: leverage,
            trading_id: accountId
        },
        success: function () {
            window.location.reload();
        },
        error: function (xhr) {
            const errors = xhr.responseJSON && xhr.responseJSON.errors;
            const msg = Array.isArray(errors) ? errors[0] : window.translations.undefined_error;
            $.bootstrapGrowl(msg, {delay: 3000, type: 'danger'});
        }
    });

});

window.getCurrencies = function getCurrencies(type, button = '') {

    if(button) {
        button.parent().addClass('m-active');
        button.attr('disabled', true);
        $('.j-currency_type').prev().text(button.text());
    }

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'POST',
        url: '/getCurrencies',
        data: { 'currency_type': type, 'sort_a_z': readSortAZCurrenciesState() ? 1 : 0 },
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {

                $('.j-crypto__table').html(msg['currenciesHTML']);
                $('#trades').html(msg['tradesHTML']);
                initSectionSortable();

                $('.j-currency_type').children().removeClass('m-active').attr('disabled', false);
                $('.j-currency_type').children().children().attr('disabled', false);

                $('.j-currency_type').attr('data-type', type);
                $('.j-favourite_currencies').removeClass('m-active');

                createCloseTradeSlider();
                fixSidebar();
                if (msg['grand_total'] === undefined) {
                    console.error('[profit] grand_total missing from response');
                    return;
                }
                renderProfitTotal($('#history .j-trades-summary'), parseFloat(msg['grand_total']) || 0);

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
        }
    });

}

window.findNearestBar = function findNearestBar(bars, tradeTime) {
    let nearestBar = null;
    let minDiff = Infinity;
    for (const bar of bars) {
        const diff = Math.abs(bar.time - tradeTime);
        if (diff < minDiff) {
            minDiff = diff;
            nearestBar = bar;
        }
    }
    return nearestBar;
}

function syncFavouriteButtonState(currencyId, isFavorite) {
    const button = $('.j-make_favourite');
    const active = isFavorite === true || isFavorite === 1 || isFavorite === '1' || isFavorite === 'true';
    const primaryText = active ? window.translations.favourites_remove : window.translations.favourites_add;
    const secondaryText = active ? window.translations.from_favourites : window.translations.in_favourites;

    button.toggleClass('m-active', active);
    button.attr('data-id', currencyId);

    const label = button.find('p').first();

    if(label.length > 0) {
        const secondary = label.find('span').first();

        label.contents().filter(function() {
            return this.nodeType === Node.TEXT_NODE;
        }).first().replaceWith(primaryText + ' ');

        if(secondary.length > 0) {
            secondary.text(secondaryText || '');
        }
    } else {
        button.text(primaryText);
    }
}

const SORT_A_Z_CURRENCIES_STORAGE_KEY = 'sort_a_z_currencies';

function persistSortAZCurrenciesState(isActive) {
    try {
        window.localStorage.setItem(SORT_A_Z_CURRENCIES_STORAGE_KEY, isActive ? '1' : '0');
    } catch (e) {}
}

function readSortAZCurrenciesState() {
    try {
        return window.localStorage.getItem(SORT_A_Z_CURRENCIES_STORAGE_KEY) === '1';
    } catch (e) {
        return false;
    }
}

function syncSortAZCurrenciesState() {
    $('.j-sort_a_z_currencies').toggleClass('m-active', readSortAZCurrenciesState());
}

function loadFavorites(enabled, callback) {
    const token = $('meta[name="csrf-token"]').attr('content');
    const type = $('.j-currency_type').attr('data-type');
    $.ajax({
        headers: { 'X-CSRF-TOKEN': token },
        type: 'POST',
        url: '/favouriteCurrencies',
        data: { '_token': token, 'currency_type': type, 'enabled': enabled, 'sort_a_z': readSortAZCurrenciesState() ? 1 : 0},
        dataType: 'json',
        success: function(msg) {
            if(msg['success'] == true) {
                $('.j-crypto__table').html(msg['html']);
                if(typeof callback === 'function') callback(msg);
            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }
        },
        error: function() {
            $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
        }
    });
}

$('.j-currency_type').on('click', 'button', function() {

    var button = $(this),
        type = button.attr('data-id');

    getCurrencies(type, button);

});

$(() => {
    syncSortAZCurrenciesState();
});

$('body').on('click', '.j-sort_a_z_currencies', function() {
    const button = $(this);
    const isActive = !button.hasClass('m-active');
    const type = $('.j-currency_type').attr('data-type');

    persistSortAZCurrenciesState(isActive);
    button.toggleClass('m-active', isActive);

    if($('.j-favourite_currencies').hasClass('m-active')) {
        loadFavorites(false);
        return;
    }

    getCurrencies(type);
});

$('body').on('click', '.j-favourite_currencies', function() {
    var button = $(this),
        enabled = false;

    if(button.hasClass('m-active')) {
        var enabled = true;
    }

    loadFavorites(enabled, function() { button.toggleClass('m-active'); });

});

$('body').on('click', '.j-make_favourite', function() {

    var button = $(this),
        enabled = false;

    if(button.hasClass('m-active')) {
        var enabled = true;
    }

    var token = $('meta[name="csrf-token"]').attr('content'),
        currency = $(this).attr('data-id'),
        data = { '_token': token, 'currency': currency, 'enabled': enabled };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/makeFavourite',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {
                var isCurrentlyFavorite = button.hasClass('m-active');
                var isFavoriteNow = !isCurrentlyFavorite;

                if(isCurrentlyFavorite) {
                    $.bootstrapGrowl(window.translations.favourites_removed, {type: 'success', delay: 3000});
                } else {
                    $.bootstrapGrowl(window.translations.favourites_added, {type: 'success', delay: 3000});
                }

                syncFavouriteButtonState(currency, isFavoriteNow);

                if($('.j-favourite_currencies').hasClass('m-active')) {
                    loadFavorites(false);
                }

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
        }
    });

});

const getActiveTheme = () => (bodyElement?.getAttribute(themeAttr) === "light" ? "light" : "dark");
const DARK_CHART_BG = "#181B16";
const LIGHT_CHART_BG = "#ffffff";
const TV_INDICATOR_PRESET_STORAGE_KEY_PREFIX = "tv_indicator_preset_v1";
let currentChartArgs = null;
let clearIndicatorsWidgetButton = null;

function getThemeCssValue(name, fallback) {
    const source = bodyElement || document.body;

    if (!source || typeof getComputedStyle !== "function") {
        return fallback;
    }

    const value = getComputedStyle(source).getPropertyValue(name).trim();

    return value || fallback;
}

function getChartColors(theme) {
    const defaultBg = theme === "light" ? LIGHT_CHART_BG : DARK_CHART_BG;
    const background = getThemeCssValue("--chart-bg", defaultBg);
    const loading = getThemeCssValue(
        "--chart-loading-color",
        getThemeCssValue("--accent-color", "#47B935")
    );

    return { background, loading };
}

function getTradingViewCssUrl() {
    const customTheme = String(window.webtraderChartSettings?.customTheme || '').toLowerCase();

    return customTheme === 'bloomx' ? '/css/tradingview-bloomx.css' : '/css/tradingview.css';
}

function getIndicatorPresetStorageKey() {
    const clientId = $('.j-chart').attr('data-client-id') || 'guest';
    return `${TV_INDICATOR_PRESET_STORAGE_KEY_PREFIX}:${clientId}`;
}

function getChartIndicatorCount(chart) {
    if (!chart || typeof chart.getAllStudies !== "function") {
        return 0;
    }

    try {
        const studies = chart.getAllStudies();
        return Array.isArray(studies) ? studies.length : 0;
    } catch (e) {
        return 0;
    }
}

function saveIndicatorPresetToStorage(chart) {
    if (!chart || typeof chart.createStudyTemplate !== "function") {
        return;
    }

    const storageKey = getIndicatorPresetStorageKey();
    const indicatorCount = getChartIndicatorCount(chart);

    if (!indicatorCount) {
        window.localStorage.removeItem(storageKey);
        return;
    }

    try {
        const studyTemplate = chart.createStudyTemplate({
            saveSymbol: false,
            saveInterval: false,
        });

        if (studyTemplate && typeof studyTemplate === "object") {
            window.localStorage.setItem(storageKey, JSON.stringify(studyTemplate));
        }
    } catch (error) {
        console.warn("Unable to save indicator preset", error);
    }
}

function applyIndicatorPresetFromStorage(chart) {
    if (!chart || typeof chart.applyStudyTemplate !== "function") {
        return false;
    }

    const storageKey = getIndicatorPresetStorageKey();
    const rawPreset = window.localStorage.getItem(storageKey);

    if (!rawPreset) {
        return false;
    }

    try {
        const preset = JSON.parse(rawPreset);
        if (!preset || typeof preset !== "object") {
            return false;
        }

        chart.applyStudyTemplate(preset);
        return true;
    } catch (error) {
        console.warn("Unable to apply indicator preset", error);
        return false;
    }
}

function clearAllChartIndicators(chart) {
    if (!chart || typeof chart.getAllStudies !== "function" || typeof chart.removeEntity !== "function") {
        return;
    }

    try {
        const studies = chart.getAllStudies();
        if (Array.isArray(studies)) {
            studies.forEach((study) => {
                if (study && study.id) {
                    chart.removeEntity(study.id);
                }
            });
        }
    } catch (error) {
        console.warn("Unable to clear indicators from chart", error);
    }

    window.localStorage.removeItem(getIndicatorPresetStorageKey());
}

function updateClearIndicatorsButton(chart) {
    if (!clearIndicatorsWidgetButton) {
        return;
    }

    const isChartLoaded = $('.j-chart').hasClass('j-loaded');
    const hasIndicators = getChartIndicatorCount(chart) > 0;
    clearIndicatorsWidgetButton.classList.toggle('m-visible', Boolean(isChartLoaded && hasIndicators));
}

function createClearIndicatorsWidgetButton(widget, chart) {
    if (!widget || typeof widget.createButton !== "function") {
        return;
    }

    const twButtonClasses = 'button-OhqNVIYA button-ptpAHg8E withText-ptpAHg8E button-GwQQdU8S apply-common-tooltip isInteractive-GwQQdU8S accessible-GwQQdU8S'

    const mountButton = () => {
        if (widget !== window.tvWidget) {
            return;
        }

        const button = widget.createButton();

        button.classList.add("tv-clear-indicators-btn");
        twButtonClasses.split(' ').forEach(cl => button.classList.add(cl));

        button.textContent = window.translations.clear_indicators;
        button.addEventListener("click", () => {
            clearAllChartIndicators(chart);
            updateClearIndicatorsButton(chart);
        });

        clearIndicatorsWidgetButton = button;
        updateClearIndicatorsButton(chart);
    };

    if (typeof widget.headerReady === "function") {
        widget.headerReady().then(mountButton).catch((error) => {
            console.warn("TradingView header is not ready for custom button", error);
        });
        return;
    }

    mountButton();
}

function isMobileDevice() {
    const uaDataMobile = typeof navigator.userAgentData?.mobile === "boolean"
        ? navigator.userAgentData.mobile
        : null;

    if (uaDataMobile !== null) {
        return uaDataMobile;
    }

    const userAgent = navigator.userAgent || "";
    const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);

    return isMobileUA && navigator.maxTouchPoints > 0;
}

function loadChart(currency, type, precision, timeframe = '15') {

    $('#chartContainer').html('');
    clearIndicatorsWidgetButton = null;
    window._orderPreviewLines = {};

    currentChartArgs = { currency, type, precision, timeframe };

    if (window.tvWidget && typeof window.tvWidget.remove === "function") {
        try {
            window.tvWidget.remove();
        } catch (e) {
            console.warn("Unable to remove previous chart", e);
        }
    }

    const chartTheme = getActiveTheme();
    const chartColors = getChartColors(chartTheme);
    const chartBg = chartColors.background;
    const disabledFeatures = [
        "context_menus",
        "timezone_menu",
        "symbol_info",
        "source_selection_markers",
        "timeframes_toolbar",
        "border_around_the_chart",
        "save_chart_properties_to_local_storage",
        "use_localstorage_for_settings",
        "widget_logo",
        "create_volume_indicator_by_default",
        "legend_widget",
        "main_series_scale_menu",
        "show_object_tree",
        "show_chart_property_page",
        "header_symbol_search",
        "header_resolutions",
        "header_compare",
        "header_saveload",
        "header_screenshot",
        "header_undo_redo",
        "header_fullscreen_button",
        "header_settings",
    ];
    const addDisabledFeatures = (features = []) => {
        features.forEach((feature) => {
            if (!disabledFeatures.includes(feature)) {
                disabledFeatures.push(feature);
            }
        });
    };
    const isMobile = isMobileDevice();

    if (isMobile) {
        addDisabledFeatures(["mouse_wheel_scale", "pinch_scale", "axis_pressed_mouse_move_scale"]);
    }
    const disableHistoryScroll = Boolean(window.webtraderChartSettings?.disableHistoryScroll);
    const disableHistoryScrollMobile = Boolean(window.webtraderChartSettings?.disableHistoryScrollMobile);

    if (disableHistoryScroll || (disableHistoryScrollMobile && isMobile)) {
        addDisabledFeatures(["chart_scroll", "mouse_wheel_scroll", "pressed_mouse_move_scroll", "horz_touch_drag_scroll", "vert_touch_drag_scroll"]);
    }

    const widget = new TradingView.widget({
        locale: webtraderLocalization.chartLocale(document.documentElement.lang),
        symbol: currency,
        interval: timeframe,
        container: 'chartContainer',
        autosize: true,
        allow_symbol_change: false,
        datafeed: Datafeed,
        library_path: '../charting_library/',
        disabled_features: disabledFeatures,
        theme: chartTheme,
        overrides: {
            'paneProperties.background': chartBg,
            'paneProperties.backgroundType': 'solid',
            // "mainSeriesProperties.candleStyle.upColor": "#3d992f",
            // "mainSeriesProperties.candleStyle.downColor": "#d13e31",
            // "mainSeriesProperties.candleStyle.borderUpColor": "#3d992f",
            // "mainSeriesProperties.candleStyle.borderDownColor": "#d13e31",
            // "mainSeriesProperties.candleStyle.wickUpColor": "#3d992f",
            // "mainSeriesProperties.candleStyle.wickDownColor": "#d13e31",
        },
        loading_screen: { backgroundColor: chartBg, foregroundColor: chartColors.loading },
        custom_css_url: getTradingViewCssUrl(),
        timezone: $('.j-chart').attr('data-timezone'),
    });

    window.tvWidget = widget;

    // widget.onChartReady(() => {

    //     if($(window).width() <= 767) {
    //         widget.activeChart().executeActionById("drawingToolbarAction");
    //     }

    //     $('.j-chart').addClass('j-loaded');

    //     widget.activeChart().crossHairMoved().subscribe(
    //         null,
    //         function ({ entityValues }) {

    //             var values = entityValues._seriesId;

    //             if(values.isHovered) {
    //                 var currentBar = { 'open' : values.values[0].value, 'high' : values.values[1].value, 'low' : values.values[2].value, 'close' : values.values[3].value };
    //             } else {
    //                 var chartContainer = $('#chartContainer');
    //                 var currentBar = { 'open' : chartContainer.attr('data-open'), 'high' : chartContainer.attr('data-high'), 'low' : chartContainer.attr('data-low'), 'close' : chartContainer.attr('data-close') };
    //             }

    //             setTopBar(currentBar);

    //         }
    //     );

    // });

    widget.onChartReady(() => {
        if (widget !== window.tvWidget) {
            return;
        }

        let chart = null;
        try {
            chart = widget.activeChart();
        } catch (e) {
            return;
        }

        if (!chart || typeof chart.getTimeScale !== 'function') {
            return;
        }

        const timeScale = chart.getTimeScale();
        let saveIndicatorPresetTimer = null;

        const scheduleIndicatorPresetSave = () => {
            if (widget !== window.tvWidget) {
                return;
            }

            if (saveIndicatorPresetTimer) {
                clearTimeout(saveIndicatorPresetTimer);
            }

            saveIndicatorPresetTimer = setTimeout(() => {
                if (widget !== window.tvWidget) {
                    return;
                }

                saveIndicatorPresetToStorage(chart);
                updateClearIndicatorsButton(chart);
            }, 500);
        };

        timeScale.setBarSpacing(10);

        if ($(window).width() <= 767) {
            chart.executeActionById("drawingToolbarAction");
        }

        $('.j-chart').addClass('j-loaded');
        createClearIndicatorsWidgetButton(widget, chart);
        applyIndicatorPresetFromStorage(chart);
        updateClearIndicatorsButton(chart);
        updateTakeProfitHint();
        updateStopLossHint();

        chart.crossHairMoved().subscribe(
            null,
            function ({ entityValues }) {
                var values = entityValues._seriesId;

                if (values.isHovered) {
                    var currentBar = {
                        open: values.values[0].value,
                        high: values.values[1].value,
                        low: values.values[2].value,
                        close: values.values[3].value
                    };
                } else {
                    var chartContainer = $('#chartContainer');
                    var currentBar = {
                        open: chartContainer.attr('data-open'),
                        high: chartContainer.attr('data-high'),
                        low: chartContainer.attr('data-low'),
                        close: chartContainer.attr('data-close')
                    };
                }

                setTopBar(currentBar);
            }
        );

        if (typeof widget.subscribe === "function") {
            widget.subscribe("study", scheduleIndicatorPresetSave);
            widget.subscribe("study_event", scheduleIndicatorPresetSave);
            widget.subscribe("study_properties_changed", scheduleIndicatorPresetSave);
        }

        // Sync button state in case applyStudyTemplate updates studies asynchronously.
        setTimeout(() => updateClearIndicatorsButton(chart), 0);
        setTimeout(() => updateClearIndicatorsButton(chart), 350);

    });

}

// window.drawTradeMarkers = function drawTradeMarkers(chart, bar, options = {}) {
//     const {
//         side = 'buy',
//         type = 'open',
//         buyColor = '#47B935',
//         sellColor = '#f23645',
//         gapMultiplier = 4
//     } = options;

//     if (!chart || !bar) return console.warn('Missing chart or bar data');

//     const timeSec = Math.floor(Number(bar.time) / 1000);
//     const { open, close, high, low } = bar;
//     if (![open, close, high, low].every(isFinite)) return;

//     const candleHeight = Math.max(1e-8, high - low);
//     const gap = Math.max((high - low) * 0.15, candleHeight * 0.01 * gapMultiplier);
//     const basePrice = close < low ? close : low;
//     const iconPrice = side === 'buy' ? basePrice - gap : high + gap;

//     const color = side === 'buy' ? buyColor : sellColor;

//     const icon = side === 'buy' ? 0xf0d8 /* up arrow */ : 0xf0d7 /* down arrow */;

//     if (!window._tradeMarkers) window._tradeMarkers = [];

//     // 🧹 Remove duplicates on same candle+side
//     window._tradeMarkers = window._tradeMarkers.filter(m => {
//         try {
//             const shapeObj = chart.getShapeById(m.id);
//             if (!shapeObj) return false;
//             const pts = shapeObj.getPoints?.();
//             if (pts?.[0]?.time === timeSec && m.side === side) {
//                 chart.removeEntity(m.id);
//                 return false;
//             }
//         } catch {}
//         return true;
//     });

//     try {

//         // 🎯 Add text marker (proper vertical offset for each side)
//         const textOffsetY = side === "buy" ? gap * 0.9 : gap * 1.4; // push further away
//         const textOffsetX = 1; // left shift (adjust as needed)

//         const labelText = side === "buy" ? " ▲\n B" : " S\n ▼";

//         const textId = chart.createMultipointShape(
//             [{ time: timeSec, channel: side === "buy" ? "low" : "high" }],
//             // [{ time: timeSec + textOffsetX, price: iconPrice + textOffsetY }],
//             {
//                 shape: "text",
//                 text: labelText,
//                 color,
//                 disableSelection: true,
//                 lock: true,
//                 zOrder: 'top',
//                 overrides: {
//                     fontsize: 12,
//                     bold: true,
//                     color: color,
//                 }
//             }
//         );

//         if (textId) {
//             window._tradeMarkers.push({ id: textId, time: timeSec, side, type: "label" });
//         }
//     } catch (e) {
//         console.error(`Failed to draw ${type.toUpperCase()} marker`, e);
//     }
// };

// window.drawTradeMarkers = function drawTradeMarkers(chart, bar, options = {}) {
//     const {
//         side = 'buy',
//         type = 'open',
//         buyColor = '#47B935',
//         sellColor = '#f23645',
//         gapMultiplier = 4
//     } = options;

//     if (!chart || !bar) return console.warn('Missing chart or bar data');

//     const timeSec = Math.floor(Number(bar.time) / 1000);
//     const { open, close, high, low } = bar;
//     if (![open, close, high, low].every(isFinite)) return;

//     const candleHeight = Math.max(1e-8, high - low);
//     const gap = Math.max((high - low) * 0.15, candleHeight * 0.01 * gapMultiplier);
//     const basePrice = close < low ? close : low;
//     const price = side === 'buy' ? basePrice - gap : high + gap;

//     const color =
//         side === 'buy' ? buyColor : sellColor;

//     // ✅ use TradingView icon font codes, not Unicode
//     const icon =
//        side === 'buy'
//         ? 0xf0d8 // arrow-up
//         : 0xf0d7; // arrow-down

//     if (!window._tradeMarkers) window._tradeMarkers = [];

//     // 🧹 remove any existing marker for same bar+side
//     window._tradeMarkers = window._tradeMarkers.filter(m => {
//         try {
//             const shapeObj = chart.getShapeById(m.id);
//             if (!shapeObj) return false;
//             const pts = shapeObj.getPoints?.();
//             if (pts?.[0]?.time === timeSec && m.side === side) {
//                 chart.removeEntity(m.id);
//                 return false;
//             }
//         } catch {}
//         return true;
//     });

//     // 🎯 create the icon marker
//     try {
//         const shapeId = chart.createMultipointShape(
//             [{ time: timeSec, price }],
//             {
//                 shape: "icon",
//                 color,
//                 icon,
//                 disableSelection: true,
//                 lock: true,
//                 zOrder: 'top',
//                 overrides: {
//                     size: 10,
//                     angle: 1.571,
//                     scale: 1.0,
//                     color
//                 }
//             }
//         );

//         if (shapeId) {
//             window._tradeMarkers.push({ id: shapeId, time: timeSec, side, type });
//         }
//     } catch (e) {
//         console.error(`Failed to draw ${type.toUpperCase()} marker`, e);
//     }
// };

window.drawTradeMarkers = function drawTradeMarkers(chart, bar, options = {}) {
    const {
        side = 'buy',
        type = 'open',
        buyColor = '#47B935',
        sellColor = '#f23645',
        closeColor = '#FFA500',
        gapMultiplier = 4
    } = options;

    if (!chart || !bar) return console.warn('Missing chart or bar data');

    const timeSec = Math.floor(Number(bar.time) / 1000);
    const { open, close, high, low } = bar;
    if (![open, close, high, low].every(isFinite)) return;

    // --- Geometry ---
    const candleHeight = Math.max(1e-8, high - low);
    const gap = Math.max((high - low) * 0.15, candleHeight * 0.01 * gapMultiplier);

    // If close < low, place marker on close instead of low
    const basePrice = close < low ? close : low;
    const price = side === 'buy' ? basePrice - gap : high + gap;

    const color = type === 'close' ? closeColor : (side === 'buy' ? buyColor : sellColor);
    const shape = side === 'buy' ? 'arrow_up' : 'arrow_down';
    const label = `\n${side.toUpperCase()}\n\n`;

    if (!window._tradeMarkers) window._tradeMarkers = [];

    // 🧹 Remove any existing marker on SAME candle AND SAME side (buy/sell)
    window._tradeMarkers = window._tradeMarkers.filter(m => {
        try {
            const shapeObj = chart.getShapeById(m.id);
            if (!shapeObj) return false;

            const pts = shapeObj.getPoints?.();
            const markerTime = pts?.[0]?.time;
            if (markerTime === timeSec && m.side === side) {
                chart.removeEntity(m.id);
                return false;
            }
        } catch (err) {
            console.warn('Error checking/removing marker:', err);
        }
        return true;
    });

    // 🎯 Create new marker
    try {
        const shapeId = chart.createMultipointShape(
            [{ time: timeSec, price }],
            {
                shape,
                text: label,
                disableSelection: true,
                lock: true,
                zOrder: 'top',
                overrides: { fontsize: 8, bold: true, scale: 0.1, size: 1, markerSize: 0.7, linewidth: 1 }
            }
        );

        if (shapeId) {
            window._tradeMarkers.push({
                id: shapeId,
                time: timeSec,
                side,
                type
            });
        }
    } catch (e) {
        console.error(`Failed to draw ${type.toUpperCase()} marker`, e);
    }

};

function updateTradeForm(freeMargin) {

    var form = $('#trade');
    var budget = applyRestrictedOrderLimit(parseFloat(freeMargin) || 0);

    form.find('[name="free_margin"]').val(freeMargin);
    form.find('.j-free_margin').text(freeMargin);

    commision = budget * parseFloat(form.find('[name="commission"]').val()) / 100
    maxQuantity = ((budget - commision) * parseFloat(form.find('[name="leverage"]').val() || 1)) / parseFloat(form.find('[name="bid_price"]').val());

    $('.j-trade_slider').attr('data-max', maxQuantity);

    createTradeSlider();

    initOneClickTrading();

}

window.getAccount = function getAccount() {

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'POST',
        url: '/getAccount',
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {

                if (window.updateMarginWarning) window.updateMarginWarning(msg.marginWarnings || msg.marginWarning);
                const accountCurrency = $('#top').attr('data-account_currency');

                $('.j-p_total_balance').html(accountCurrency + ' <span class="j-total_balance">'+ formatTerminalAmount(msg['totalBalance']) +'</span>');
                $('.j-p_bonus').html(accountCurrency + ' <span class="j-bonus">'+ formatTerminalAmount(msg['bonusFunds']) +'</span>');
                $('.j-p_credit').html(accountCurrency + ' <span class="j-credit">'+ formatTerminalAmount(msg['creditFunds']) +'</span>');
                $('.j-p_free_margin').html(accountCurrency + ' <span class="j-free_margin">'+ formatTerminalAmount(msg['freeMargin']) +'</span>');
                $('.j-p_used_funds').html(accountCurrency + ' <span class="j-used_funds">'+ formatTerminalAmount(msg['usedFunds']) +'</span>');
                $('.j-p_used_margin_percent').html('('+ formatTerminalPercent(msg['usedMarginPercent']) +'%)');
                $('.j-p_equity').html(accountCurrency + ' <span class="j-equity">'+ formatTerminalAmount(msg['equity']) +'</span>');
                $('.j-p_open_pnl').html(accountCurrency + ' <span class="j-open_pnl">'+ formatTerminalAmount(msg['openPnl']) +'</span>');
                updateOpenPnlPercent()

                updateTradeForm(msg['freeMargin']);

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
        }
    });

}

window.openCurrency = function openCurrency(currency, timeframe = '15', updateForm = true, listingData = false) {

    $('.j-chart').removeClass('j-loaded');

    var token = $('meta[name="csrf-token"]').attr('content'),
        data = { '_token': token, 'currency': currency, 'timeframe': timeframe, 'updateForm': updateForm };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: '/openCurrency',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {

                $('.j-content').attr({ 'data-currency' : msg['currency'], 'data-precision' : msg['precision'], 'data-oldprice' : msg['oldprice'] });
                $('.j-currency_top').html(msg['currencyHTML']);
                $('[name="search"]').val('');
                $('[name="search"]').next().removeClass('m-active');
                $('.j-timeframes').attr('data-defaulttimeframe', timeframe);
                $('.j-timeframes').find('.j-open_currency').attr('data-id', msg['currency_id']);
                $('.j-crypto__table').find('.j-open_currency[data-id='+ msg['currency_id'] +'] .j-current_price').text($('.j-currency_top .j-current_price').text());
                syncFavouriteButtonState(msg['currency_id'], msg['is_favorite']);

                if(listingData) {
                    if (listingData.month_only) {
                        $('#chartContainer').html(
                            '<div class="b-listing b-listing--month-only">' +
                                '<div class="listing_chart"></div>' +
                                '<div class="b-listing_month_info">' +
                                    '<p class="b-listing_month_title">' + window.translations.pre_listing_title + '</p>' +
                                    '<p class="b-listing_month_sub">' + (listingData.pending_text || window.translations.ipo_prospectus_pending) + '</p>' +
                                    '<p class="b-listing_month_expected">(' + window.translations.expected + ' ' + listingData.month + ')</p>' +
                                '</div>' +
                            '</div>'
                        );
                    } else {
                        $('#chartContainer').html('<div class="b-listing"><div class="listing_chart"></div><img src="/img/timer.svg" alt=""><div class="b-listing_counter"><p>'+ window.translations.estimate +'</p><div class="j-listing_timer" data-range=\'' + JSON.stringify(listingData) + '\'><span class="days">00</span><span class="hours">00</span><span class="minutes">00</span><span class="seconds">00</span></div></div></div>');
                    }
                    $('.j-chart').addClass('j-loaded');
                } else {
                    loadChart(msg['currency_name'], msg['type'], msg['precision'], timeframe);
                }

                if(updateForm == true) {
                    $('#trade').html(msg['tradeHTML']);
                    updateTradeForm($('#top .j-free_margin').text());
                }

                initSelect2();

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
        }
    });

}

$('body').on('click', '.j-copy', function(e) {

    $('.bootstrap-growl').remove();

    var aux = $(this).prev();
    aux.select();
    document.execCommand("copy");

    $.bootstrapGrowl(window.translations.copied, {type: 'success', delay: 3000 });

});

$('body').on('click', '.j-open_currency', function() {

    if ($(window).width() <= 991) {
        $('.j-sidebar').fadeOut();
    }

    $('.j-chart').removeClass('j-loaded');

    var button = $(this),
        currency = button.attr('data-id'),
        listing = button.attr('data-listing'),
        timeframe = $('.j-timeframes').attr('data-defaultTimeframe');

    if (typeof button.attr('data-timeframe') !== 'undefined') {
        timeframe = button.attr('data-timeframe');
    }

    if(button.hasClass('m-timeframe')) {
        button.parent().children().attr("disabled", false);
        button.attr("disabled", true);
    }

    let parsedData = false;

    if (listing && listing !== 'null') {
        try {
            parsedData = JSON.parse(listing);
        } catch (e) {
            console.error("Invalid JSON:", e);
        }
    }

    openCurrency(currency, timeframe, true, parsedData);

});

$('body').on('keyup', '[name="search"]', function() {

    var token = $('meta[name="csrf-token"]').attr('content'),
        search = $(this).val(),
        dropdown = $(this).next(),
        data = { '_token': token, 'search': search };

    if(!search) {
        dropdown.removeClass('m-active');
    } else {

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': token
            },
            type: 'POST',
            url: '/search',
            data: data,
            dataType: 'json',
            success: function( msg ) {

                if(msg['success'] == true) {

                    if (!dropdown.hasClass('m-active')){
                        dropdown.addClass('m-active');
                    }

                    if(msg['count'] == 0) {
                        dropdown.html('<span>'+ window.translations.no_results +'</span>');
                    } else {
                        dropdown.html(msg['html']);
                    }

                } else {
                    $.bootstrapGrowl(msg['message'], {delay: 3000});
                }

            },
            error: function(data) {
                $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
            }
        });

    }

});

const TRADES_DIGEST_POLL_INTERVAL_MS = 5000;
let tradesDigestState = null;
let tradesDigestRequestInFlight = false;
let tradesDigestRefreshInFlight = false;
let tradesDigestPollTimer = null;

function refreshTradesFromDigest() {

    if (tradesDigestRefreshInFlight) {
        return;
    }

    tradesDigestRefreshInFlight = true;
    tradesDigestState = null;

    loadTrades('open');
    loadTrades('pending');
    loadHistoryTrades();
    getAccount();

    setTimeout(function() {
        tradesDigestRefreshInFlight = false;
    }, 1200);

}

function pollTradesDigest() {

    const openBlock = $('#open');

    if (openBlock.length === 0 || tradesDigestRequestInFlight) {
        return;
    }

    const account = openBlock.attr('data-account');

    if (!account) {
        return;
    }

    tradesDigestRequestInFlight = true;

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        type: 'POST',
        url: '/tradesDigest',
        data: { 'account': account },
        dataType: 'json',
        success: function(msg) {

            if (msg['success'] !== true || !msg['digest']) {
                return;
            }

            if (tradesDigestState === null) {
                tradesDigestState = msg['digest'];
                return;
            }

            if (tradesDigestState !== msg['digest']) {
                tradesDigestState = msg['digest'];
                refreshTradesFromDigest();
            }

        },
        complete: function() {
            tradesDigestRequestInFlight = false;
        }
    });

}

function initTradesDigestPolling() {

    if ($('#open').length === 0 || tradesDigestPollTimer) {
        return;
    }

    pollTradesDigest();
    tradesDigestPollTimer = setInterval(pollTradesDigest, TRADES_DIGEST_POLL_INTERVAL_MS);

}

window.loadTrades = function loadTrades(id) {

    var block = $('#' + id),
        account = block.attr('data-account'),
        status = block.attr('data-status'),
        data = { 'account': account, 'status': status };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        type: 'POST',
        url: '/loadTrades',
        data: data,
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {

                $('body > .dropdown-menu').remove();
                block.html(msg['html']);

                if (id === 'open' && isCompactModalOpen() && $('tr[data-id="' + window.compactModalTradeId + '"]').length === 0) {
                    $.magnificPopup.close();
                }

                createCloseTradeSlider();
                fixSidebar()

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            var errors = data.responseJSON;
            console.log(errors);
        }
    });

}

window.loadHistoryTrades = function loadHistoryTrades(showLoadMore = false, page = 1) {

    var block = $('#history'),
        account = block.attr('data-account'),
        pageCount = block.find('select[name="page_count"]').val() || 5,
        dateRange = block.find('select[name="date_range"]').val() || 'all',
        currencyId = block.find('select[name="currency_id"]').val(),
        tradeType = block.find('select[name="trade_type"]').val() || 'all',
        data = {
            'account': account,
            'page_count': pageCount,
            'date_range': dateRange,
            'currency_id': currencyId,
            'trade_type': tradeType,
            'showLoadMore': showLoadMore,
            'page': page
        };

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
        },
        type: 'POST',
        url: '/loadHistoryTrades',
        data: data,
        dataType: 'json',
        success: function( msg ) {
            const historyTradesContainer = block.find('.j-trades-container')

            if(msg['success'] == true) {

                $('body > .dropdown-menu').remove();
                historyTradesContainer.html(msg['html']);
                initSelect2()
                if (msg['grand_total'] === undefined) {
                    console.error('[profit] grand_total missing from response');
                    return;
                }
                renderProfitTotal(block.find('.j-trades-summary'), parseFloat(msg['grand_total']) || 0);
                fixSidebar()

            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            var errors = data.responseJSON;
            console.log(errors);
        }
    });

}

window.updateOpenPnl = function updateOpenPnl() {

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        type: 'POST',
        url: '/updateOpenPnl',
        dataType: 'json',
        success: function( msg ) {

            if(msg['success'] == true) {
                console.log(msg);
            } else {
                $.bootstrapGrowl(msg['message'], {delay: 3000});
            }

        },
        error: function(data) {
            $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
        }
    });

}

function loadMore(id) {

    var element = $('#' + id + ' .j-load_more');

    if(element.length > 0 && element.is(":visible") && loading == false) {

        var hT = element.offset().top,
            hH = element.outerHeight(),
            wH = $('#page_scroll').height(),
            wS = $(this).scrollTop();

        if (wS > (hT+hH-wH)) {

            loading = true;

            setTimeout(function() {

                var block = element.parent().find('table'),
                    token = $('meta[name="csrf-token"]').attr('content'),
                    page = element.attr('data-page'),
                    account = element.attr('data-account'),
                    status = element.attr('data-status'),
                    data = { '_token': token, 'page': page, 'account': account, 'status': status };

                $.ajax({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="_token"]').attr('content')
                    },
                    type: 'POST',
                    url: '/loadMore',
                    data: data,
                    dataType: 'json',
                    success: function( msg ) {

                        if(msg['success'] == true) {

                            loading = false;
                            block.append(msg['html']);

                            if(msg['hide'] == true) {
                                element.remove();
                            } else {
                                element.attr('data-page', parseInt(page) + 1);
                            }

                            fixSidebar()

                        } else {
                            $.bootstrapGrowl(msg['message'], {delay: 3000});
                        }

                    },
                    error: function(data) {
                        var errors = data.responseJSON;
                        console.log(errors);
                    }
                });

            }, 1000);

        }

    }

}

$('body').on('click', '#history .j-history-pagination a', function (e) {
    e.preventDefault();
    var href = $(this).attr('href') || '';
    var pageMatch = href.match(/[?&]page=(\d+)/);
    var page = pageMatch ? parseInt(pageMatch[1], 10) : 1;
    loadHistoryTrades(false, page);
});

function renderProfitTotal(summaryEl, total) {
    const summary = $(summaryEl);
    const currency = summary.data('currency') || '';
    const label = (currency ? currency + ' ' : '') + formatMoney(total, 2);

    summary.find('.j-total-profit')
        .text(label)
        .toggleClass('m-up', total >= 0)
        .toggleClass('m-down', total < 0);
}

function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

      const negativeSign = amount < 0 ? "-" : "";

      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;

      return negativeSign +
        (j ? i.substr(0, j) + thousands : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) +
        (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
}

/******** validate fields ********/

$('body').on('change', '[name="payment"]', function() {
    var isMonumpay = $(this).val() === 'monumpay';
    $('.j-monumpay_extra').css('display', isMonumpay ? '' : 'none');
    var isDragonpay = $(this).val() === 'dragonpay';
    $('.j-dragonpay_extra').css('display', isDragonpay ? '' : 'none');
    var isVertexpay = $(this).val() === 'vertexpay';
    $('.j-vertexpay_extra').css('display', isVertexpay ? '' : 'none');
});

function fillBrowserFingerprint(form) {
    var fields = form.find('.j-browser_fp');

    if (!fields.length) {
        return;
    }

    var fingerprint = {
        screen_width: screen.width,
        screen_height: screen.height,
        color_depth: screen.colorDepth,
        tz: -(new Date().getTimezoneOffset()),
        language: navigator.language || 'en',
        java_enabled: (typeof navigator.javaEnabled === 'function' && navigator.javaEnabled()) ? '1' : '0'
    };

    fields.each(function() {
        var key = $(this).data('fp');
        if (fingerprint.hasOwnProperty(key)) {
            $(this).val(fingerprint[key]);
        }
    });
}

function validation(id, usingClass = false) {
    var current = '#' + id + ' button[type="submit"]';

    if(usingClass == true) {
        current = '.j-' + id + ' button[type="submit"]';
    }

    $('body').on('click', current, function(e) {

        e.preventDefault();

        $('.bootstrap-growl').remove();

        var button = $(this),
            form = $(this).closest('form'),
            token = $('meta[name="csrf-token"]').attr('content'),
            data;

        fillBrowserFingerprint(form);

        data = new FormData(form.get(0));

        form.find('input').removeClass('m-error');
        data.append('_token', token);
        data.append('timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);

        if (form.attr('data-with-code') == '1') {
            let code = $('.iti__selected-dial-code').text();
            data.set('phone', code + $('#phone').val());
        }

        if($(this).attr('data-fields') == 'dob' || $(this).attr('data-fields') == 'password') {
            data.append('fields', $(this).attr('data-fields'));
        }

        button.attr("disabled", true).addClass('m-loading');

        $.ajax({
            type: "POST",
            url: '/' + id + 'Validation',
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            success: function( msg ) {

                if(id != 'login' && id != 'deposit' && id != 'insurance') {
                    button.attr("disabled", false).removeClass('m-loading');
                }

                if(msg['success'] == true) {

                    if(id == 'trade') {

                        const target = msg['status'] == 1 ? '#open' : '#pending';

                        $(`${target} table tfoot`).remove();
                        $(`${target} table tr:first`).after(msg['html']);

                        createCloseTradeSlider();
                        resetTradeForm();

                        $('[name="free_margin"]').val(msg['free_margin']);

                        $('.j-free_margin').text(formatTerminalAmount(msg['free_margin']));
                        $('.j-used_funds').text(formatTerminalAmount(msg['used_funds']));
                        $('.j-p_used_margin_percent').text('(' + formatTerminalPercent(msg['used_margin_percent']) + '%)');
                        updateTradeForm(msg['free_margin']);

                        $('input[name="bid_price"]').removeClass('m-edited');

                        setEquity();
                        initSelect2();
                        tradesDigestState = null;
                        // addMarkerOnChart(msg);

                        $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});

                    } else if(id == 'transfer') {
                        $('.mfp-close').trigger('click')
                        $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});
                    } else if(id == 'setTakeProfit' || id == 'setStopLoss') {

                        var $modal = $('.j-compact_trade_modal');
                        if (isCompactModalOpen() && $modal.length) {
                            $.ajax({
                                type: 'GET',
                                url: '/getTradeDetails',
                                data: { trade_id: window.compactModalTradeId },
                                dataType: 'json',
                                success: function (res) {
                                    if (res['success'] === true) {
                                        $modal.html(res['html']);
                                        initSelect2();
                                    }
                                }
                            });
                        } else {
                            var oldOrder = $('tr[data-id="'+ data.get('trade_id') +'"]');

                            if(id == 'setTakeProfit') {
                                oldOrder.find('.j-take_profit button').dropdown('toggle');
                            } else {
                                oldOrder.find('.j-stop_loss button').dropdown('toggle');
                            }

                            oldOrder.after(msg['html']);
                            oldOrder.remove();
                            initSelect2();
                        }

                        $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});

                    } else if(id == 'closeOrder' || id == 'cancelOrder') {

                        var oldOrder = $('tr[data-id="'+ data.get('trade_id') +'"]');
                        oldOrder.find('.j-close_button').dropdown('toggle');

                        if(id == 'cancelOrder') {
                            var dropdown = $('[data-dropdown_id="'+ data.get('trade_id') +'_cancel"]');
                            dropdown.find('.j-close_dropdown').click();
                        }

                        if(msg['partial']) {
                            oldOrder.after(msg['html']);
                        }

                        $('#history table tfoot').remove();
                        loadHistoryTrades()

                        oldOrder.remove();
                        createCloseTradeSlider();

                        var tab = 'open';

                        if(id == 'cancelOrder') {
                            var tab = 'pending';
                        }

                        if($('#'+ tab +' table tr').length <= 1) {
                            $('#'+ tab +' table').append('<tfoot><tr><td colspan="100%">'+ window.translations.no_orders +'</td></tr></tfoot>');
                        }

                        $('[name="free_margin"]').val(msg['free_margin']);

                        $('.j-total_balance').text(formatTerminalAmount(msg['total_balance']));
                        $('.j-free_margin').text(formatTerminalAmount(msg['free_margin']));
                        $('.j-used_funds').text(formatTerminalAmount(msg['used_funds']));
                        $('.j-p_used_margin_percent').text('(' + formatTerminalPercent(msg['used_margin_percent']) + '%)');
                        updateTradeForm(msg['free_margin']);

                        if(id == 'closeOrder') {

                            var sum = 0;

                            if($('#open .j-trade').length > 0) {
                                sum = setPnl();
                            } else {
                                $('.j-open_pnl').text('0.00');
                                updateOpenPnlPercent()
                            }

                            setEquity(sum);
                            // addMarkerOnChart(msg);

                        }

                        if (isCompactModalOpen() && window.compactModalTradeId == data.get('trade_id')) {
                            $.magnificPopup.close();
                        }

                        initSelect2();
                        tradesDigestState = null;

                        $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});

                    } else if(id == 'profile') {
                        $('input[name="old_password"], input[name="password"], input[name="password_confirmation"]').val('');
                        $.bootstrapGrowl(window.translations.profile_updated, {type: 'success', delay: 3000 });
                    } else if(id == 'loan' || id == 'transactionLoan') {

                        $.magnificPopup.open({
                            items: {
                                src: '#loan_pop'
                            },
                            type: 'inline',
                            fixedContentPos: false,
                            fixedBgPos: true,
                            overflowY: 'auto',
                            closeBtnInside: false,
                            showCloseBtn:false,
                            preloader: false,
                            midClick: true,
                            removalDelay: 300,
                            closeOnBgClick: false,
                            mainClass: 'my-mfp-slide-bottom',
                        });

                    } else if(id == 'bank') {
                        window.open(msg['target'], "_blank", "location=yes,height=570,width=520,scrollbars=yes,status=yes");
                        window.location.replace(msg['redirect']);
                    } else if(id == 'calculator') {
                        var calculatorForm = $('#calculator');
                        calculatorForm.find('.j-contract_size').text(msg['contractSize'] || '0.00');
                        calculatorForm.find('.j-tick').text(msg['tick'] || '0.00');
                        calculatorForm.find('.j-pip_value').text(msg['pipValue'] || '0.00');
                        calculatorForm.find('.j-swap_short').text(msg['swapShort'] || '0.00');
                        calculatorForm.find('.j-swap_long').text(msg['swapLong'] || '0.00');
                        calculatorForm.find('.j-required_margin').text(msg['requiredMargin'] || '0.00');
                        calculatorForm.find('.j-commission_value').text(msg['commission'] || '0.00');
                        calculatorForm.find('.j-profit_value').text(msg['profit'] || '0.00');
                    } else if(msg['transaction'] == true) {
                        $('.j-transaction_modal').html(msg['html']);
                        $('select').select2();
                    } else if(id == 'contact') {
                        $('[name="name"], [name="email"], [name="phone"], [name="message"]').val('');
                        $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});
                        button.attr("disabled", false).removeClass('m-loading');
                    } else if(id == 'message') {

                        $('.j-support').find('.support__chat').append(msg['html']);
                        $('.j-support').find('[name="message"]').val('');

                        $('input[name="upload_files[]"]')[0].value = ''; // clear files
                        $('.j-upload_file span').remove();

                        button.attr("disabled", false).removeClass('m-loading');
                        $('.support__chat').scrollTop($('.support__chat')[0].scrollHeight);

                    } else {

                        if(msg['redirect']) {
                            window.location.replace(msg['redirect']);
                        } else if(msg['reload']) {
                            window.location.reload();
                        } else {
                            //
                        }

                    }

                } else {

                    button.attr("disabled", false).removeClass('m-loading');

                    if(msg['errors'] == undefined) {
                        $.bootstrapGrowl(msg['message'], {delay: 3000});
                    } else {
                        var errors = '';
                        $.each(msg['errors'], function(index, values) {

                            var element = form.find('[name=' + index + ']');

                            if(element.is('select')) {
                                element.next().addClass('m-error');
                            } else if(element.is('input[type="radio"]')) {
                                element.parent().addClass('m-error');
                            } else {
                                element.addClass('m-error');
                            }

                            $.each(values, function(index, value) {
                                errors = errors + value + '<br>';
                            });
                        });

                        $.bootstrapGrowl(errors, {delay: 3000});
                    }

                }

            },
            error: function(data) {
                button.attr("disabled", false).removeClass('m-loading');
                var response = data.responseJSON;
                if (id === 'trade' && response && response.error === 'deposit_gate') {
                    $.bootstrapGrowl(response.message, {delay: 6000});
                    return;
                }
                if (data.status === 419) {
                    $.bootstrapGrowl(window.translations.session_expired || window.translations.undefined_error, {delay: 3000});
                    setTimeout(function() { window.location.reload(); }, 1500);
                    return;
                }
                $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
           }
        });

    });

}

function initSelect2() {

    $('select').select2();
    initCalculatorCurrencySelect();

    $('select.m-quantity').select2({
        dropdownCssClass: 'm-quantity'
    });

    $('select.m-accounts').select2({
        templateResult: function (data) {
            if (!data.id) {
            return data.text;
            }
            var $result = $('<span></span>');
            $result.text(data.text);

            // Add class from <option class="...">
            if (data.element) {
            $result.addClass($(data.element).attr("class"));
            }
            return $result;
        },
        templateSelection: function (data) {
            var $selection = $('<span></span>');
            $selection.text(data.text);

            if (data.element) {
            $selection.addClass($(data.element).attr("class"));
            }
            return $selection;
        }
    });

    initHistoryCurrencySelect();

}

function normalizeSymbolSearchValue(value) {
    return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]+/g, '');
}

function initCalculatorCurrencySelect() {
    var calculatorCurrencySelect = $('#calculator [name="currency_id"]');

    if (!calculatorCurrencySelect.length) {
        return;
    }

    if (calculatorCurrencySelect.hasClass('select2-hidden-accessible') && calculatorCurrencySelect.data('select2')) {
        calculatorCurrencySelect.select2('destroy');
    }

    calculatorCurrencySelect.select2({
        matcher: function(params, data) {
            var term = normalizeSymbolSearchValue(params.term);
            if (!term) {
                return data;
            }

            var optionSearch = '';
            if (data.element) {
                optionSearch = $(data.element).attr('data-search') || '';
            }

            var haystack = normalizeSymbolSearchValue(data.text) + normalizeSymbolSearchValue(optionSearch);
            if (haystack.indexOf(term) !== -1) {
                return data;
            }

            return null;
        }
    });
}

function initHistoryCurrencySelect() {
    const historyTab = $('#history');
    const historyAllCurrenciesText = (window.translations && window.translations.history_all_currencies)
        ? window.translations.history_all_currencies
        : 'All currencies';
    const historyCurrencySelectors = historyTab.find('select.history-currency-picker');

    if (historyCurrencySelectors.length === 0) {
        return;
    }

    historyCurrencySelectors.each(function () {
        const $select = $(this);

        if ($select.hasClass('select2-hidden-accessible') && $select.data('select2')) {
            $select.select2('destroy');
        }

        $select.select2({
            allowClear: false,
            minimumInputLength: 0,
            ajax: {
                url: '/searchCurrencies',
                type: 'POST',
                dataType: 'json',
                delay: 300,
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                },
                data: function (params) {
                    return {
                        search: params.term || ''
                    };
                },
                processResults: function (data) {
                    const remoteResults = Array.isArray(data.results) ? data.results : [];
                    const hasAllOption = remoteResults.some(function (item) {
                        return String(item.id) === 'all';
                    });

                    const results = hasAllOption
                        ? remoteResults
                        : [{ id: 'all', text: historyAllCurrenciesText }].concat(remoteResults);

                    return {
                        results: results
                    };
                },
                cache: true
            }
        });
    });
}

$('body').on('change', '.trades-filters select', function () {
    const tabPane = $(this).closest('.tab-pane');
    if (!tabPane.length || !tabPane.attr('id')) {
        return;
    }

    if (tabPane.attr('id') === 'history') {
        loadHistoryTrades();
        return;
    }

});

$('body').on('change', '#history .j-history-page-count-picker', function () {
    loadHistoryTrades();
});

$('body').on('shown.bs.tab', '.b-tabs [data-bs-toggle="tab"]', function () {
    if ($(this).attr('data-bs-target') === '#history') {
        initSelect2();
    }
});

function makeListingTimer() {

    var timerClass = $(".j-listing_timer");

    if (timerClass.length > 0) {
        timerClass.each(function () {
            var range = $(this).data("range");

            if (!range || !range.to) return;

            var endTime = Date.parse(new Date(range.to)) / 1000;
            var now = Date.parse(new Date()) / 1000;

            var timeLeft = endTime - now;

            if (timeLeft > 0) {
                var days = Math.floor(timeLeft / 86400);
                var hours = Math.floor((timeLeft % 86400) / 3600);
                var minutes = Math.floor((timeLeft % 3600) / 60);
                var seconds = Math.floor(timeLeft % 60);

                // Pad values
                days = days < 10 ? "0" + days : days;
                hours = hours < 10 ? "0" + hours : hours;
                minutes = minutes < 10 ? "0" + minutes : minutes;
                seconds = seconds < 10 ? "0" + seconds : seconds;

                // Update spans
                $(this).find(".days").text(days);
                $(this).find(".hours").text(hours);
                $(this).find(".minutes").text(minutes);
                $(this).find(".seconds").text(seconds);
            } else {

                clearInterval(refreshIntervalId);

                $(this).find(".days").text("00");
                $(this).find(".hours").text("00");
                $(this).find(".minutes").text("00");
                $(this).find(".seconds").text("00");

                let currency = $('.j-content').data('id');
                let timeframe = $('.j-timeframes').data('defaulttimeframe');

                openCurrency(currency, timeframe, true);

                const sidebarRow = $('.j-open_currency[data-id="' + currency + '"]');

                sidebarRow.attr('data-listing', null);
                sidebarRow.find('.crypto-price').addClass('j-current_price');
                sidebarRow.find('.crypto-percent').children().addClass('j-change_percent');

            }
        });
    }
}

var refreshIntervalId = setInterval(makeListingTimer, 1000);

////////

$(window).on('resize', function() {
    fixSidebar();
    enableScroll();
});

$(document).ready(function() {

    validation('login');
    validation('trade');
    validation('setTakeProfit', true);
    validation('setStopLoss', true);
    validation('closeOrder', true);
    validation('cancelOrder', true);

    validation('register');
    validation('profile');
    validation('verification');
    // validation('loan');
    validation('transactionLoan');
    validation('trading');
    validation('bank');
    validation('deposit');
    validation('transfer');
    validation('insurance');
    validation('withdraw');
    validation('calculator');
    validation('contact');
    validation('message');
    initTradesDigestPolling();

    $('body').on('click', '.js-edit-trading-account', function () {
        const accountId = String($(this).data('account-id'));
        const accountName = String($(this).data('account-name') || '').trim();
        const accountTypeId = String( $(this).data('account-type-id')|| '0').trim();
        const form = $('#trading-account-edit-form');
        const summaryType = form.find('[data-field="account_type_badge"]');

        form.find('[name="account_id"]').val(accountId);
        form.find('[data-field="account_summary_display"]').text(accountName + ' #' + accountId);
        summaryType
            .removeClass('m-type-0 m-type-1')
            .addClass('m-type-' + accountTypeId);
        form.find('[name="name"]').val(accountName);

        $.magnificPopup.open({
            items: { src: '#trading_account_edit_pop' },
            type: 'inline',
            fixedContentPos: true,
            fixedBgPos: true,
            overflowY: 'auto',
            closeBtnInside: false,
            showCloseBtn: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            closeOnBgClick: false,
            mainClass: 'my-mfp-slide-bottom'
        });
    });

    $('body').on('submit', '#trading-account-edit-form', function (e) {
        e.preventDefault();

        const form = $(this);
        const accountId = String(form.find('[name="account_id"]').val() || '').trim();
        const accountName = String(form.find('[name="name"]').val() || '').trim();

        if (!accountId.length || !accountName.length) {
            return;
        }

        const submitButton = form.find('button[type="submit"]');
        submitButton.attr('disabled', true).addClass('m-loading');

        $.ajax({
            url: '/update-trading-name',
            method: 'POST',
            data: {
                _token: $('meta[name="csrf-token"]').attr('content'),
                account_id: accountId,
                name: accountName
            },
            success: function () {
                $.bootstrapGrowl(window.translations.profile_updated, {type: 'success', delay: 3000});
                $.magnificPopup.close();
                window.setTimeout(function () {
                    window.location.reload();
                }, 300);
            },
            error: function (xhr) {
                const error = xhr?.responseJSON?.errors?.name?.[0]
                    || xhr?.responseJSON?.message
                    || window.translations.undefined_error;

                $.bootstrapGrowl(error, {delay: 3000});
            },
            complete: function () {
                submitButton.attr('disabled', false).removeClass('m-loading');
            }
        });
    });

    createTradeSlider();
    enableScroll();

    $('body').on('show.bs.dropdown', 'table .btn-group', function() {

        var oldDropdown = $('body').children('.dropdown-menu');

        if(oldDropdown.length > 0) {
            $('table .btn-group[data-dropdown_id="'+ oldDropdown.attr('data-dropdown_id') +'"]').children('button').click();
        }

        var dropdown = $(this).find('.dropdown-menu');

        $('body').append(dropdown.css({
          position: 'absolute',
          left: dropdown.offset().left,
          top: dropdown.offset().top
        }).detach());

    });

    $('body').on('hidden.bs.dropdown', 'table .btn-group', function() {

        $(this).append($('body').children('.dropdown-menu').css({
          position: false,
          left: false,
          top: false
        }).detach());

        const dropdownId = $(this).attr('data-dropdown_id') || '';
        if (dropdownId.endsWith('_profit')) {
            setOrderPreviewLine('take_profit', null);
        } else if (dropdownId.endsWith('_loss')) {
            setOrderPreviewLine('stop_loss', null);
        }

    });

    $('body').on('click', '.j-close_dropdown', function() {
        var dropdown = $(this).closest('.dropdown-menu'),
            group = dropdown.closest('.btn-group');

        // Fallback for table dropdowns moved to body (existing behavior).
        if(group.length === 0) {
            group = $('table .btn-group[data-dropdown_id="'+ dropdown.attr('data-dropdown_id') +'"]');
        }

        var toggle = group.children('[data-bs-toggle="dropdown"]').first();
        if(toggle.length === 0) {
            toggle = group.children('button').first();
        }

        if(toggle.length === 0) {
            return;
        }

        if(window.bootstrap && bootstrap.Dropdown) {
            bootstrap.Dropdown.getOrCreateInstance(toggle[0]).hide();
        } else {
            toggle.click();
        }

    });

    $('body').on('click', '.j-pass_action', function(e) {
        if($(this).hasClass('m-active')) {
            $(this).removeClass('m-active');
            $(this).prev().prop('type', 'password');
        } else {
            $(this).addClass('m-active');
            $(this).prev().prop('type', 'text');
        }
    });

    $('body').on('click', 'button[data-dismiss="alert"]', function(e) {
        $(this).parent().remove();
    });

    if($('#crypto_table').length > 0) {
        new SimpleBar($('#crypto_table')[0]);
    }

    if($('#page_scroll').length > 0) {
        var simpleBar = new SimpleBar($('#page_scroll')[0]);
        simpleBar.getScrollElement().addEventListener('scroll', scrollHandler, { passive: true });
    }

    loading = false;

    function scrollHandler (event) {
        loadMore('open');
        loadMore('pending');
    }

    if(!$('#content').hasClass('m-page')) {
        fixSidebar();
    }

    $('input').bind('focus',function() {
        $(this).removeClass('m-error');
    });

    $('body').on('change keyup input', 'input, textarea', function() {
        $(this).removeClass('m-error');
    });

    $('body').on('shown.bs.tab', '.b-tabs [data-bs-toggle="tab"]', function () {
        fixSidebar();
    });

    $('body').on('change', 'select', function(e) {
        $(this).next().removeClass('m-error');
    });

    $('body').on('change', '#calculator [name="currency_id"]', function() {
        var selected = $(this).find('option:selected');
        var marketPrice = selected.attr('data-bid');

        if (marketPrice) {
            var calculatorForm = $('#calculator');
            calculatorForm.find('[name="entry_price"]').val(marketPrice).removeClass('m-error');
            calculatorForm.find('[name="exit_price"]').val(marketPrice).removeClass('m-error');
        }
    });

    $('body').on('input change', '#calculator [name="leverage"]', function() {
        var calculatorForm = $('#calculator');
        var slider = calculatorForm.find('.j-calc_slider');
        var uiBlock = slider.closest('.b-ui');
        var maxLabel = uiBlock.find('.m-max');
        var value = parseFloat($(this).val());

        if (isNaN(value) || value <= 0) {
            return;
        }

        var roundedValue = Math.max(1, Math.round(value));

        if (slider.length && slider.data('ui-slider')) {
            var currentMax = parseInt(slider.slider('option', 'max'), 10) || 1;
            if (roundedValue > currentMax) {
                slider.slider('option', 'max', roundedValue);
                if (maxLabel.length) {
                    maxLabel.text(roundedValue + 'x');
                }
            }

            slider.slider('value', roundedValue);
        }

        uiBlock.find('.j-range').text(formatMoney(roundedValue, 0));
        $(this).val(roundedValue);
    });

    $('body').on('click', '.j-options > div', function(e) {
        $('.j-options > div').removeClass('m-checked m-error');
        $(this).addClass('m-checked');
        $(this).find('input[type="radio"]').prop("checked", true).trigger('change');
    });

    initSelect2();

    $('body').on('keyup', '.j-only_numbers', function() {
        this.value = this.value.replace(/[^0-9\.]/g,'');
    });

    $('body').on('focus', 'input[name="bid_price"]', function() {
        $(this).addClass('m-edited');
    });

    $('body').on('change', '.j-split input[type="checkbox"]', function() {

        const name = $(this).attr('name').replace('_checkbox', '');
        const div = $('[data-name="'+ name +'"]');

        if ($(this).is(":checked")) {
            div.show();       // Show the div
            div.focus();      // Optional: focus inside it
        } else {
            div.hide();       // Hide the div
            div.val('');      // Clear value if it's an input
        }

        if (name === 'take_profit') {
            updateTakeProfitHint();
        } else if (name === 'stop_loss') {
            updateStopLossHint();
        }
    });

    $('body').on('click', '.j-sign_panel', function() {
        $(this).next().submit();
    });

    $('body').on('input', '.j-type_switch', function(e) {

        var form = $(this).closest('form');
        form.find('.j-partial').toggleClass('d-none');
        if($(this).val() == 0) {
            form.find('.j-pnl').removeClass('j-manual').text(form.find('[name="pnl_all"]').val());
            form.find('[name="amount"]').val('0');
            form.find('.j-amount').text('0');
            form.find('.j-close_trade_slider').slider('value', 0);
            $('.j-close_trade_slider').find('.label-slider').removeClass('m-active');
        } else if($(this).val() == 1) {
            form.find('.j-pnl').addClass('j-manual').text(0);
        }

    });

    $('body').on('change', '[name="type_id"]', function(e) {

        var type = $('[name="type_id"]:checked').val(),
            typeWord = window.translations.buy;

        if(type == 1) {
            var typeWord = window.translations.sell;
        }

        $('.j-type_word').parent().attr('data-type', type);
        $('.j-type_word').text(typeWord);

        budget = applyRestrictedOrderLimit(parseFloat($('[name="free_margin"]').val()) || 0),
        entryPrice = parseFloat($('[name="bid_price"]').val()),
        commision = budget * parseFloat($('[name="commission"]').val()) / 100;
        maxQuantity = parseFloat(((budget - commision) * $('[name="leverage"]').val() || 1) / entryPrice);

        $('.j-trade_slider').attr('data-max', maxQuantity);

        resetTradeForm();

    });

    $('body').on('change', '.j-setTakeProfit [name="exit_tp"], .j-setStopLoss [name="exit_sl"]', function() {

        const exitType = parseInt($(this).val());
        const form = $(this).closest('form');
        const potential = form.find('.j-exit_potential[data-id="' + (exitType === 0 ? 1 : 0) + '"]').find('.j-potential').text();
        const price = form.find('[name="price"]');

        price.val(Math.abs(potential));

    });

    // The engine triggers a BUY stop/target on bid and a SELL one on ask, and
    // the trade row's .j-current_price cell shows exactly that side. Pending
    // orders fill at the entry price, so it stays their reference. Returns
    // null when no live price is available (e.g. hidden column) — then the
    // server-side check is the only validator.
    function getStopReferencePrice(form, entryPrice) {
        let row = form.closest('tr.j-trade');

        if (!row.length) {
            row = $('tr.j-trade[data-id="' + form.find('[name="trade_id"]').val() + '"]');
        }

        if (row.length && row.closest('#pending').length) {
            return { price: entryPrice, isEntry: true };
        }

        const current = parseFloat((row.find('.j-current_price').first().text() || '').replace(/,/g, ''));

        return Number.isFinite(current) && current > 0 ? { price: current, isEntry: false } : null;
    }

    $('body').on('keyup', '.j-setTakeProfit [name="price"], .j-setStopLoss [name="price"]', function () {

        $('.bootstrap-growl').remove();

        const $input = $(this);
        const form = $input.closest('form');
        const value = parseFloat($input.val()) || 0;
        const entryPrice = parseFloat(form.find('[name="entry_price"]').val()) || 0;
        const type = parseInt(form.find('[name="type_id"]').val()); // 0 = Buy, 1 = Sell
        const quantity = parseFloat(form.find('[name="quantity"]').val()) || 1;

        // detect which dropdown is used (exit_tp for TP, exit_sl for SL)
        const exitType = parseInt(form.find('[name="exit_tp"], [name="exit_sl"]').val()) || 0; // 0 = price, 1 = pnl

        const isTakeProfit = form.hasClass('j-setTakeProfit');
        const isStopLoss = form.hasClass('j-setStopLoss');
        const fieldName = isStopLoss ? 'stop_loss' : 'take_profit';

        let exitPrice = 0;
        let pnl = 0;

        // --- CASE 1: user entered EXIT PRICE ---
        if (exitType === 0) {
            exitPrice = value;

            // A stop above entry (long) locks in profit, so the PnL keeps its
            // real sign here — only the market-side check below rejects it.
            if (type === 0) { // BUY
                pnl = (exitPrice - entryPrice) * quantity;
            } else { // SELL
                pnl = (entryPrice - exitPrice) * quantity;
            }

        // --- CASE 2: user entered PNL directly ---
        } else {
            pnl = value;

            // In PNL mode the Stop Loss input means "max loss"
            if (isStopLoss && pnl > 0) pnl = -Math.abs(pnl);

            if (type === 0) { // BUY
                exitPrice = entryPrice + (pnl / quantity);
            } else { // SELL
                exitPrice = entryPrice - (pnl / quantity);
            }
        }

        // --- Update UI ---
        form.find('.j-exit_potential[data-id="0"] .j-potential').text(pnl.toFixed(2));
        form.find('.j-exit_potential[data-id="1"] .j-potential').text(exitPrice.toFixed(2));

        // A profit-locking stop shows a positive potential — flip the static
        // "Potential loss/profit" label to match the sign
        const potentialLabel = form.find('.j-exit_potential[data-id="0"] > span').first();
        if (potentialLabel.length && window.translations.potential_profit && window.translations.potential_loss) {
            const defaultLabel = isStopLoss ? window.translations.potential_loss : window.translations.potential_profit;
            potentialLabel.text(pnl > 0 ? window.translations.potential_profit : (pnl < 0 ? window.translations.potential_loss : defaultLabel));
        }

        $input.removeClass('m-error');

        if (!value) {
            setOrderPreviewLine(fieldName, null);
            return;
        }

        // --- Validation: the level must sit on the trigger side of the
        // reference price (current market for open trades, entry for pending)
        const reference = getStopReferencePrice(form, entryPrice);

        if (reference === null) {
            setOrderPreviewLine(fieldName, exitPrice);
            return;
        }

        let message = null;

        if (isStopLoss) {
            if (type === 0 && exitPrice >= reference.price) {
                message = reference.isEntry ? window.translations.stop_loss_more : window.translations.stop_loss_above_market;
            } else if (type === 1 && exitPrice <= reference.price) {
                message = reference.isEntry ? window.translations.stop_loss_less : window.translations.stop_loss_below_market;
            }
        } else if (isTakeProfit) {
            if (type === 0 && exitPrice <= reference.price) {
                message = reference.isEntry ? window.translations.take_profit_less : window.translations.take_profit_below_market;
            } else if (type === 1 && exitPrice >= reference.price) {
                message = reference.isEntry ? window.translations.take_profit_more : window.translations.take_profit_above_market;
            }
        }

        if (message) {
            $.bootstrapGrowl(message + ' (' + reference.price + ')', { delay: 3000 });
            form.find('.j-exit_potential[data-id="0"] .j-potential').text('0.00');
            $input.addClass('m-error');
            setOrderPreviewLine(fieldName, null);
        } else {
            setOrderPreviewLine(fieldName, exitPrice);
        }
    });

    if($('.j-timezone').length > 0) {
        $('.j-timezone').val(Intl.DateTimeFormat().resolvedOptions().timeZone);
    }

    if($('.j-chart').attr('data-timezone') == '') {
        $('.j-chart').attr('data-timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);
    }

    $('body').on('click', '.j-open_search', function() {
        $('.j-sidebar').fadeIn();
    });

    $('body').on('click', '.j-close_search', function() {
        $('.j-sidebar').fadeOut();
    });

    $('body').on('click', '.mfp-close', function() {
        $(this).remove();
    });

    $('body').on('click', '.j-remove_stop', function() {

        var button = $(this),
            token = $('meta[name="csrf-token"]').attr('content'),
            trade = $(this).parent().parent().find('[name="trade_id"]').val(),
            type = $(this).attr('data-type');
            data = { '_token': token, 'trade_id': trade, 'type': type };

        button.attr("disabled", true).addClass('m-loading');

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': token
            },
            type: 'POST',
            url: '/removeStop',
            data: data,
            dataType: 'json',
            success: function( msg ) {

                button.attr("disabled", false).removeClass('m-loading');

                if(msg['success'] == true) {

                    var $modal = $('.j-compact_trade_modal');
                    if (window.compactModalTradeId !== null && $modal.length) {
                        $.ajax({
                            type: 'GET',
                            url: '/getTradeDetails',
                            data: { trade_id: window.compactModalTradeId },
                            dataType: 'json',
                            success: function (res) {
                                if (res['success'] === true) {
                                    $modal.html(res['html']);
                                    initSelect2();
                                }
                            }
                        });
                    } else {
                        var oldOrder = $('tr[data-id="'+ trade +'"]');

                        if(type == 'profit') {
                            oldOrder.find('.j-take_profit button').dropdown('toggle');
                        } else {
                            oldOrder.find('.j-stop_loss button').dropdown('toggle');
                        }

                        oldOrder.after(msg['html']);
                        oldOrder.remove();
                        initSelect2();
                    }

                    $.bootstrapGrowl(msg['message'], {type: 'success', delay: 3000});

                } else {
                    $.bootstrapGrowl(msg['message'], {delay: 3000});
                }

            },
            error: function(data) {
                button.attr("disabled", false).removeClass('m-loading');
                $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
            }
        });

    });

    $('body').on('keyup', '.j-phone', function(e) {
        var ph = this.value.replace(/\D/g,'').substring(0,10);
        // Backspace and Delete keys
        var deleteKey = (e.keyCode == 8 || e.keyCode == 46);
        var len = ph.length;
        if(len==0){
            ph=ph;
        }else if(len<3){
            ph='('+ph;
        }else if(len==3){
            ph = '('+ph + (deleteKey ? '' : ') ');
        }else if(len<6){
            ph='('+ph.substring(0,3)+') '+ph.substring(3,6);
        }else if(len==6){
            ph='('+ph.substring(0,3)+') '+ph.substring(3,6)+ (deleteKey ? '' : '-');
        }else{
            ph='('+ph.substring(0,3)+') '+ph.substring(3,6)+'-'+ph.substring(6,10);
        }
        this.value = ph;
    });

    $('body').on('keyup', '.j-date', function(e) {
        var ph = this.value.replace(/\D/g,'').substring(0,8);
        // Backspace and Delete keys
        var deleteKey = (e.keyCode == 8 || e.keyCode == 46);
        var len = ph.length;
        if(len<2){
            ph=ph;
        }else if(len == 2){
            ph = ph + (deleteKey ? '' : '/');
        }else if(len < 4){
            ph= ph.substring(0, 2)+'/'+ph.substring(2,4);
        }else if(len == 4){
            ph= ph.substring(0, 2)+'/'+ph.substring(2,4) + (deleteKey ? '' : '/');
        }else{
            ph= ph.substring(0, 2)+'/'+ph.substring(2,4)+'/'+ph.substring(4,8);
        }
        this.value = ph;
    });

    $('body').on('keyup', '.j-exp', function(e) {
        var ph = this.value.replace(/\D/g,'').substring(0,8);
        // Backspace and Delete keys
        var deleteKey = (e.keyCode == 8 || e.keyCode == 46);
        var len = ph.length;
        console.log(len);
        if(len < 2) {
            ph=ph;
        }else if(len == 2){
            ph = ph + (deleteKey ? '' : ' / ');
        } else {
            ph= ph.substring(0, 2)+' / '+ph.substring(2,4);
        }
        this.value = ph;
    });

    $('body').on('keyup', '.j-card', function(e) {
        var ph = this.value.replace(/\D/g,'').substring(0, 16);
        // Backspace and Delete keys
        var deleteKey = (e.keyCode == 8 || e.keyCode == 46);
        var len = ph.length;
        if(len < 4) {
            ph=ph;
        }else if(len == 4){
            ph = ph + (deleteKey ? '' : ' ');
        }else if(len < 8){
            ph= ph.substring(0, 4)+' '+ph.substring(4,8);
        }else if(len == 8){
            ph= ph.substring(0, 4)+' '+ph.substring(4,8) + (deleteKey ? '' : ' ');
        }else if(len < 12){
            ph= ph.substring(0, 4)+' '+ph.substring(4,8)+' '+ph.substring(8,12);
        }else if(len == 12){
            ph= ph.substring(0, 4)+' '+ph.substring(4,8)+' '+ph.substring(8,12) + (deleteKey ? '' : ' ');
        } else {
            ph= ph.substring(0, 4)+' '+ph.substring(4,8)+' '+ph.substring(8,12)+' '+ph.substring(12,16);
        }
        this.value = ph;
    });

    $('.j-modal_profile').magnificPopup({
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: false,
        showCloseBtn:true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        closeOnBgClick: false,
        mainClass: 'my-mfp-slide-bottom',
        callbacks: {
            beforeOpen: function() {

                this.wrap.removeAttr('tabindex')

                var link = $.magnificPopup.instance.st.el;

                if(link.attr('data-type') && link.attr('data-name')) {

                    const verifyCategoryTemplate = window.translations.verify_your_category || 'Verify your :category';
                    const verifyCategoryText = verifyCategoryTemplate.replace(':category', link.attr('data-category_name'));
                    $('.j-document_category').text(verifyCategoryText);
                    $('.j-document_name').html(link.attr('data-name'));
                    $('#upload-document').attr('data-category', link.attr('data-category'));
                    $('#upload-document').attr('data-type', link.attr('data-type'));
                    $('#upload-document').val('');
                    $('[name="doc_1"]').val('');
                    $('.verification__step > div').removeClass('m-active');
                    $('.verification__step > div:first-child').addClass('m-active');
                    setKycUploadStatus('');

                    if(Number(link.attr('data-category')) === 0 && (link.attr('data-type') == 1 || link.attr('data-type') == 2)) {
                        $('.j-second').removeClass('m-hidden');
                    } else {
                        $('.j-second').addClass('m-hidden');
                    }

                } else {
                    $('[name="name"]').val('');
                    $('[name="company"]').val('').trigger('change');
                }

            }
        }
    });

    var kycDocumentUploading = false;
    var kycText = window.translations || {};

    function setKycUploadStatus(text) {
        var status = $('.j-upload_status');
        if (!status.length) {
            return;
        }

        if (!text) {
            status.text('').addClass('m-hidden');
            return;
        }

        status.text(text).removeClass('m-hidden');
    }

    function uploadSelectedKycDocument(input) {
        var files = input.files;
        if (!files || files.length === 0 || kycDocumentUploading) {
            return;
        }

        var $input = $(input);
        var button = $input.prev();
        var fd = new FormData();

        kycDocumentUploading = true;
        button.attr("disabled", true).addClass('m-loading');
        setKycUploadStatus(kycText.uploading_document || 'Uploading photo...');

        // Append data
        fd.append('document', files[0]);
        fd.append('category', $input.attr('data-category'));
        fd.append('type', $input.attr('data-type'));
        fd.append('doc_1', $('[name="doc_1"]').val());
        fd.append('_token', $('meta[name="csrf-token"]').attr('content'));

        $.ajax({
            url: '/uploadDocument',
            method: 'POST',
            data: fd,
            contentType: false,
            processData: false,
            dataType: 'json',
            success: function( msg ) {

                button.attr("disabled", false).removeClass('m-loading');
                kycDocumentUploading = false;

                if(msg['success'] == true) {

                    if(msg['doc_1']) {

                        $("#upload-document").val('');
                        $('.verification__step > div').removeClass('m-active');
                        $('.j-second').addClass('m-active');
                        $('[name="doc_1"]').val(msg['doc_1']);
                        setKycUploadStatus(kycText.kyc_upload_front_done || 'Front side uploaded. Please upload back side.');

                    } else {

                        setKycUploadStatus('');
                        $.magnificPopup.close();
                        $.bootstrapGrowl(window.translations.documents_submited, {type: 'success', delay: 3000 });

                        setTimeout(() => {
                            window.location.replace(msg['redirect']);
                        }, 1000);

                    }

                } else {
                    if(msg['errors'] == undefined) {
                        setKycUploadStatus(kycText.kyc_upload_failed || 'Upload failed. Please try again.');
                        $.bootstrapGrowl(msg['message'], {delay: 3000});
                    } else {
                        var errors = '';
                        $.each(msg['errors'], function(index, values) {
                            $.each(values, function(index, value) {
                                errors = errors + value + '<br>';
                            });
                        });

                        setKycUploadStatus(kycText.kyc_upload_failed || 'Upload failed. Please try again.');
                        $.bootstrapGrowl(errors, {delay: 3000});
                    }
                }

            },
            error: function(data) {
                kycDocumentUploading = false;
                button.attr("disabled", false).removeClass('m-loading');
                var errors = data.responseJSON;
                setKycUploadStatus(kycText.kyc_upload_failed || 'Upload failed. Please try again.');
                $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
            }
        });
    }

    // Ensures selecting the same photo again still triggers a new upload.
    $('body').on('click', '#upload-document', function() {
        this.value = '';
    });

    $('body').on('change', '#upload-document', function() {
        uploadSelectedKycDocument(this);
    });

    // Android camera flow can skip "change" after returning to the page.
    $(window).on('focus pageshow', function() {
        setTimeout(function () {
            var input = document.getElementById('upload-document');
            if (input) {
                uploadSelectedKycDocument(input);
            }
        }, 250);
    });

    // Fallback for Android camera intents returning with delayed visibility restore.
    $(document).on('visibilitychange', function() {
        if (document.hidden) {
            return;
        }

        setTimeout(function () {
            var input = document.getElementById('upload-document');
            if (input) {
                uploadSelectedKycDocument(input);
            }
        }, 250);
    });

    $('body').on('click', '#j-submit-kyc', function() {
        var button = $(this);
        button.attr('disabled', true).addClass('m-loading');

        $.ajax({
            url: '/submitKycForReview',
            method: 'POST',
            data: { _token: $('meta[name="csrf-token"]').attr('content') },
            dataType: 'json',
            success: function(msg) {
                button.attr('disabled', false).removeClass('m-loading');
                if (msg['success']) {
                    $.bootstrapGrowl(window.translations.kyc_submitted_for_review || 'Documents submitted for review', {type: 'success', delay: 3000});
                    setTimeout(function() {
                        window.location.replace(msg['redirect']);
                    }, 1000);
                } else {
                    $.bootstrapGrowl(msg['message'] || window.translations.undefined_error, {delay: 3000});
                }
            },
            error: function() {
                button.attr('disabled', false).removeClass('m-loading');
                $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
            }
        });
    });

    $('.j-calc_slider').each(function() {
        var self = $(this),
            value = parseInt(self.attr('data-value')),
            min = parseInt(self.attr('data-min')),
            max = parseInt(self.attr('data-max')),
            uiBlock = self.closest('.b-ui'),
            form = self.closest('form'),
            rangeTarget = uiBlock.find('.j-range'),
            leverageInput = form.find('[name="leverage"]'),
            maxLabel = uiBlock.find('.m-max');

        var slider = self.slider({
            create: function() {
                rangeTarget.text(formatMoney(self.slider('value'), 0));
                leverageInput.val(self.slider('value'));
            },
            slide: function(event, ui) {
                rangeTarget.text(formatMoney(ui.value, 0));
                leverageInput.val(ui.value);
            },
            range: 'min',
            min: min,
            max: max,
            step: 1,
            value: value,
        });

        if (maxLabel.length) {
            maxLabel.text(max + 'x');
        }
    });

    $('.j-loan_slider').each(function() {
        var self = $(this),
            value = parseInt(self.attr('data-value')),
            min = parseInt(self.attr('data-min')),
            max = parseInt(self.attr('data-max'));

        var slider = self.slider({
            create: function() {
                var current = self.slider('value');
                $('[name="total"]').val(current);
                $('.j-range').text(formatMoney(current, 2));
                if (typeof calcLoan === 'function') {
                    calcLoan();
                }
            },
            slide: function(event, ui) {
                var total = ui.value;

                $('[name="total"]').val(total);
                if (typeof calcLoan === 'function') {
                    calcLoan();
                }
            },
            range: 'min',
            min: min,
            max: max,
            step: 500,
            value: value,
        });
    });

    function getPluralTranslation(path, count, fallback) {
        const locale =  document.documentElement.lang || 'en';
        const segments = Array.isArray(path) ? path : String(path || '').split('.');

        let node = window.translations;
        for (const key of segments) {
            if (!node || typeof node !== 'object' || !(key in node)) {
                return fallback || '';
            }
            node = node[key];
        }

        if (typeof node !== 'object' || node === null) {
            return typeof node === 'string' ? node : (fallback || '');
        }

        if (typeof Intl !== 'undefined' && typeof Intl.PluralRules !== 'undefined') {
            const rule = new Intl.PluralRules(locale).select(Math.abs(count));
            if (node[rule]) return node[rule];
        }

        if (node.other) return node.other;
        const first = Object.values(node)[0];
        if (first) return first;

        return fallback || '';
    }

    function getLoanUnitLabel(type, count) {
        const translation = getPluralTranslation(['units', type], count, null);
        if (translation) return translation;

        if (type === 'hour') return count === 1 ? 'hour' : 'hours';
        if (type === 'day') return count === 1 ? 'day' : 'days';
        return count === 1 ? 'month' : 'months';
    }

    function getLoanPaymentLabel(type) {
        if (window.translations) {
            if (type === 'hour' && window.translations.loan_hourly_payment) {
                return window.translations.loan_hourly_payment;
            }
            if (type === 'day' && window.translations.loan_daily_payment) {
                return window.translations.loan_daily_payment;
            }
            if (window.translations.loan_monthly_payment) {
                return window.translations.loan_monthly_payment;
            }
        }

        if (type === 'hour') return 'Hourly payment';
        if (type === 'day') return 'Daily payment';
        return 'Monthly payment';
    }

    function getLoanDurationUnit(type) {
        const units = window.translations && window.translations.loan_duration_units;
        if (units && units[type]) return units[type];
        return getLoanUnitLabel(type, 2);
    }

    function getLoanDurationLabel(type) {
        const template = window.translations && window.translations.loan_select_duration;
        const unitLabel = getLoanDurationUnit(type);

        if (template) {
            return String(template).replace(':unit', unitLabel);
        }

        return 'Select the duration for loan repayment in ' + unitLabel;
    }

    function updateLoanPeriodOptions() {
        const $type = $('[name="period_type"]');
        const $select = $('[name="period"]');

        if (!$type.length || !$select.length) return;

        const type = $type.val();
        let max;

        if (type === 'hour') {
            max = 23;
        } else if (type === 'day') {
            max = 31;
        } else {
            max = 12;
        }

        let current = parseInt($select.val(), 10) || 1;
        if (current > max) current = max;

        let html = '';
        for (let i = 1; i <= max; i++) {
            html += '<option value="' + i + '"' + (i === current ? ' selected' : '') + '>' + i + '</option>';
        }
        $select.html(html);
    }

    function updateLoanPeriodTypeLabels() {
        const $type = $('[name="period_type"]');
        const $period = $('[name="period"]');

        if (!$type.length) return;

        const count = parseInt($period.val(), 10) || 1;

        $type.find('option').each(function() {
            const $option = $(this);
            const unitType = $option.val();
            $option.text(getLoanUnitLabel(unitType, count));
        });

        if ($type.hasClass('select2-hidden-accessible') && $type.data('select2')) {
            $type.select2('destroy');
            $type.select2();
        }
    }

    function updateLoanDurationLabel() {
        const $label = $('.j-select_duration');
        const $type = $('[name="period_type"]');

        if (!$label.length) return;

        const type = $type.length ? $type.val() : 'month';
        $label.text(getLoanDurationLabel(type));
    }

    $('body').on('input', '[name="total"]', function () {
        const $input = $(this);
        const $slider = $('.j-loan_slider');
        let val = parseFloat(String($input.val()).replace(/[^\d.]/g, ''));

        if (isNaN(val)) {
            calcLoan();
            return;
        }

        if ($slider.length) {
            const min = parseFloat($slider.data('min'));
            const max = parseFloat($slider.data('max'));

            if (val >= min && val <= max) {
                $slider.slider('value', val);
            }
        }

        calcLoan();
    });

    $('body').on('blur', '[name="total"]', function () {
        const $input = $(this);
        const $slider = $('.j-loan_slider');

        if (!$slider.length) {
            calcLoan();
            return;
        }

        const min = parseFloat($slider.data('min'));
        const max = parseFloat($slider.data('max'));
        let val = parseFloat(String($input.val()).replace(/[^\d.]/g, ''));

        if (isNaN(val)) val = min;
        if (val < min) val = min;
        if (val > max) val = max;

        $input.val(val);
        $slider.slider('value', val);
        calcLoan();
    });

    $('body').on('change', '[name="period"]', function() {
        updateLoanPeriodTypeLabels();
        calcLoan();
    });

    $('body').on('change', '[name="period_type"]', function() {
        updateLoanPeriodOptions();
        updateLoanDurationLabel();
        calcLoan();
    });



    function calcLoan() {

        const $totalInput = $('[name="total"]');
        const $periodInput = $('[name="period"]');
        const $periodTypeInput = $('[name="period_type"]');

        if (!$totalInput.length || !$periodInput.length) return;

        const total = parseFloat($totalInput.val()) || 0;
        const period = parseInt($periodInput.val(), 10) || 0;
        const periodType = $periodTypeInput.length ? $periodTypeInput.val() : 'month';

        if ($('.j-range').length) {
            $('.j-range').text(formatMoney(total, 2));
        }

        if (period <= 0) {
            $('.j-period').text(period || 0);
            const $unit = $('.j-period_unit');
            if ($unit.length) {
                $unit.text(getLoanUnitLabel(periodType, period || 0));
            }
            $('.j-monthly').text(formatMoney(0, 2));
            $('[name="monthly"]').val('0.00');
            return;
        }

        const installment = total / period;

        $('.j-period').text(period);
        const $unit = $('.j-period_unit');
        if ($unit.length) {
            $unit.text(getLoanUnitLabel(periodType, period));
        }
        $('.j-monthly').text(formatMoney(installment, 2));
        $('[name="monthly"]').val(installment.toFixed(2));

        const $label = $('.j-period_label');
        if ($label.length) {
            $label.text(getLoanPaymentLabel(periodType));
        }
    }

    if ($('[name="period_type"]').length && $('[name="period"]').length) {
        updateLoanPeriodOptions();
        updateLoanDurationLabel();
        calcLoan();
    } else if ($('.j-loan_slider').length) {
        calcLoan();
    }

    if ($('.j-loan_notification').length) {
        $.magnificPopup.open({
            items: {
                src: '.j-loan_notification'
            },
            type: 'inline',
            fixedContentPos: true,
            fixedBgPos: true,
            overflowY: 'auto',
            closeBtnInside: false,
            showCloseBtn: true,
            preloader: false,
            midClick: true,
            removalDelay: 300,
            closeOnBgClick: false,
            mainClass: 'my-mfp-slide-bottom',
        });
    }



    const marginCalls = require('./margin-calls')({
        hasSeen(key) {
            try { return sessionStorage.getItem('margin-call:' + key) === '1'; } catch (_) { return false; }
        },
        markSeen(key) {
            try { sessionStorage.setItem('margin-call:' + key, '1'); } catch (_) { /* Private browsing may disable storage. */ }
        },
        isBusy() { return Boolean($.magnificPopup.instance && $.magnificPopup.instance.isOpen); },
        request(kind, id, done, complete) {
            $.ajax({
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                type: 'POST',
                url: kind === 'cross' ? '/marginCallCross' : '/marginCall',
                data: kind === 'cross' ? { trading_id: id } : { trade_id: id },
                dataType: 'json', success: done, complete,
            });
        },
        open(html) {
            $.magnificPopup.open({
                items: { type: 'inline', src: '<div class="b-modal_profile b-modal_notification j-notification zoom-anim-dialog">' + html + '</div>' },
                fixedContentPos: true, fixedBgPos: true, overflowY: 'auto', closeBtnInside: false,
                showCloseBtn: true, preloader: false, midClick: true, removalDelay: 300,
                closeOnBgClick: false, mainClass: 'my-mfp-slide-bottom',
            });
        },
    });
    window.marginCall = tradeId => marginCalls.request('isolated', tradeId);
    window.marginCallCross = tradingId => marginCalls.request('cross', tradingId);
    window.updateMarginWarning = warning => marginCalls.update(warning);

    // Reload, websocket reconnects and disconnected clients all recover the same persisted episode.
    let marginStatusPending = false;
    const refreshMarginWarning = function () {
        if (!$('#top').length || marginStatusPending || document.hidden) return;
        marginStatusPending = true;
        $.ajax({
            headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
            type: 'POST', url: '/marginCallStatus', dataType: 'json',
            success: msg => { if (msg.success) marginCalls.update(msg.warnings || msg.warning); },
            complete: () => { marginStatusPending = false; },
        });
    };
    refreshMarginWarning();
    setInterval(refreshMarginWarning, 5000);
    window.addEventListener('online', refreshMarginWarning);
    document.addEventListener('visibilitychange', refreshMarginWarning);

    function normalizeTransactionType(value) {
        if (!value) {
            return '';
        }

        var normalized = String(value).trim();

        try {
            normalized = decodeURIComponent(normalized);
        } catch (e) {
            // Keep original value when decoding fails.
        }

        normalized = normalized.replace(/^https?:\/\/[^/]+/i, '');
        normalized = normalized.split('#')[0].split('?')[0];
        normalized = normalized.replace(/^\/+|\/+$/g, '');

        if (normalized.indexOf('/') !== -1) {
            var parts = normalized.split('/');
            normalized = parts[parts.length - 1];
        }

        normalized = normalized.toLowerCase();

        return ['deposit', 'withdraw', 'insurance'].indexOf(normalized) !== -1 ? normalized : '';
    }

    $('.j-make_transaction').magnificPopup({
        items: {
            type: 'inline',
            src: '<div class="b-modal_profile j-transaction_modal zoom-anim-dialog"><div class="b-loading j-loading"></div></div>',
        },
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: false,
        showCloseBtn:true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        closeOnBgClick: false,
        mainClass: 'my-mfp-slide-bottom',
        callbacks: {
            beforeOpen: function() {

                var magnificPopup = $.magnificPopup.instance,
                    rawHref = magnificPopup.st.el.attr('href'),
                    dataType = magnificPopup.st.el.attr('data-transaction_type'),
                    href = normalizeTransactionType(dataType || rawHref),
                    accountId = magnificPopup.st.el.attr('data-account_id'),
                    accountType = magnificPopup.st.el.attr('data-account_type');

                if (!href) {
                    $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
                    return false;
                }

                makeTransaction(href, accountId, accountType);

            }
        },
    });

    function makeTransaction(href, accountId = undefined, accountType = undefined) {

        var token = $('meta[name="csrf-token"]').attr('content'),
            data = { '_token': token, 'href': href, 'accountId': accountId, 'accountType': accountType };

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': token
            },
            type: 'POST',
            url: '/makeTransaction',
            data: data,
            dataType: 'json',
            success: function( msg ) {

                if(msg['success'] == true) {
                    $('.j-transaction_modal').html(msg['html']);
                    $('select').select2();

                    const accountSelect = $('.j-transaction_modal').find('select[name="account_id"]');
                    if (accountSelect.length > 0) {
                        const firstAccountValue = accountSelect.find('option[value]:not([value=""]):first').val();
                        if (firstAccountValue) {
                            accountSelect.val(firstAccountValue).trigger('change');
                        }
                    }
                } else {
                    $.bootstrapGrowl(msg['message'], {delay: 3000});
                }

            },
            error: function(data) {
                var errors = data.responseJSON;
                $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
            }
        });

    }

    $('.j-make_transfer').magnificPopup({
        items: {
            type: 'inline',
            src: '<div class="b-modal_profile j-transaction_modal zoom-anim-dialog"><div class="b-loading j-loading"></div></div>',
        },
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: false,
        showCloseBtn:true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        closeOnBgClick: false,
        mainClass: 'my-mfp-slide-bottom',
        callbacks: {
            beforeOpen: function() {
                makeTransfer();
            }
        },
    });

    function makeTransfer() {

        var token = $('meta[name="csrf-token"]').attr('content'),
            data = { '_token': token};

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': token
            },
            type: 'POST',
            url: '/makeTransfer',
            data: data,
            dataType: 'json',
            success: function( msg ) {

                if(msg['success'] == true) {
                    $('.j-transaction_modal').html(msg['html']);
                    $('select').select2();

                    const accountSelect = $('.j-transaction_modal').find('select[name="account_id"]');
                    if (accountSelect.length > 0) {
                        const firstAccountValue = accountSelect.find('option[value]:not([value=""]):first').val();
                        if (firstAccountValue) {
                            accountSelect.val(firstAccountValue).trigger('change');
                        }
                    }
                } else {
                    $.bootstrapGrowl(msg['message'], {delay: 3000});
                }

            },
            error: function(data) {
                var errors = data.responseJSON;
                $.bootstrapGrowl(window.translations.undefined_error, {delay: 3000});
            }
        });

    }

    function makeTimer() {
        var timerClass = $(".j-timer");

        if (timerClass.length > 0) {
            timerClass.each(function () {
                var $this = $(this);
                var initialRemaining = parseFloat($this.attr("data-remaining-seconds"));

                if (!Number.isFinite(initialRemaining)) {
                    var endTime = new Date($this.attr("data-end")).getTime() / 1000;
                    initialRemaining = endTime - (new Date().getTime() / 1000);
                }

                if (!$this.attr("data-timer-start")) {
                    $this.attr("data-timer-start", performance.now());
                }

                var elapsedSeconds = (performance.now() - parseFloat($this.attr("data-timer-start"))) / 1000;
                var timeLeft = initialRemaining - elapsedSeconds;

                let finalTimer = "";

                if (timeLeft > 0) {
                    var days = Math.floor(timeLeft / 86400);
                    var hours = Math.floor((timeLeft % 86400) / 3600);
                    var minutes = Math.floor((timeLeft % 3600) / 60);
                    var seconds = Math.floor(timeLeft % 60);

                    // Pad numbers < 10 with a leading zero
                    days = days < 10 ? "0" + days : days;
                    hours = hours < 10 ? "0" + hours : hours;
                    minutes = minutes < 10 ? "0" + minutes : minutes;
                    seconds = seconds < 10 ? "0" + seconds : seconds;

                    if (days > 0) {
                        finalTimer += days + ":";
                    }
                    if (hours > 0 || days > 0) {
                        finalTimer += hours + ":";
                    }

                    finalTimer += minutes + ":" + seconds;
                } else {
                    finalTimer = "00:00";
                    // Keep the trade visible at zero. If its market is closed,
                    // CRM will settle it only after the market reopens.
                    $this.removeClass("j-timer");
                }

                $this.html(finalTimer);
            });
        }
    }

    // Run updater every second
    setInterval(makeTimer, 1000);

});


function openTransactionDetails(transactionId) {
    if (window.hideTransactionDetails) {
        return;
    }

    const token = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'GET',
        url: `/transactions/${transactionId}/details`,
        dataType: 'json',
        success: function (msg) {
            if (msg['success'] === true) {
                $.magnificPopup.open({
                    items: {
                        src: `<div class="b-modal_profile j-transaction_details_modal zoom-anim-dialog">${msg['html']}</div>`,
                        type: 'inline',
                    },
                    fixedContentPos: true,
                    fixedBgPos: true,
                    overflowY: 'auto',
                    closeBtnInside: false,
                    showCloseBtn: true,
                    preloader: false,
                    midClick: true,
                    removalDelay: 300,
                    closeOnBgClick: true,
                    mainClass: 'my-mfp-slide-bottom',
                });
            } else {
                $.bootstrapGrowl(msg['message'], { delay: 3000 });
            }
        },
        error: function () {
            $.bootstrapGrowl(window.translations?.undefined_error, { delay: 3000 });
        }
    });
}

$(document).on('click', '.j-transaction_details_trigger', function (e) {
    e.preventDefault();

    const transactionId = $(this).data('transaction');

    if (!transactionId) {
        return;
    }

    openTransactionDetails(transactionId);
});

$(document).on('click', '.j-transaction-row', function (e) {
    if ($(e.target).closest('a, button').length) {
        return;
    }

    const transactionId = $(this).data('transaction-id');

    if (!transactionId) {
        return;
    }

    openTransactionDetails(transactionId);
});

window.compactModalTradeId = null;

function isCompactModalOpen() {
    return window.compactModalTradeId !== null
        && $.magnificPopup.instance
        && $.magnificPopup.instance.isOpen;
}

function openCompactTradeDetails(tradeId) {
    window.compactModalTradeId = tradeId;

    $.magnificPopup.open({
        items: {
            type: 'inline',
            src: '<div class="b-modal_profile b-compact-trade-modal j-compact_trade_modal zoom-anim-dialog"><div class="b-loading j-loading"></div></div>',
        },
        callbacks: {
            beforeOpen: function () {
                $.ajax({
                    type: 'GET',
                    url: '/getTradeDetails',
                    data: { trade_id: tradeId },
                    dataType: 'json',
                    success: function (msg) {
                        if (msg['success'] === true) {
                            $('.j-compact_trade_modal').html(msg['html']);
                            initSelect2();
                        } else {
                            $.magnificPopup.close();
                            $.bootstrapGrowl(msg['message'] || window.translations.undefined_error, { delay: 3000 });
                        }
                    },
                    error: function () {
                        $.magnificPopup.close();
                        $.bootstrapGrowl(window.translations.undefined_error, { delay: 3000 });
                    }
                });
            },
            afterClose: function () {
                window.compactModalTradeId = null;
            }
        },
        type: 'inline',
        fixedContentPos: true,
        fixedBgPos: true,
        overflowY: 'auto',
        closeBtnInside: false,
        showCloseBtn: true,
        preloader: false,
        midClick: true,
        removalDelay: 300,
        closeOnBgClick: false,
        mainClass: 'my-mfp-slide-bottom'
    });
}

$(document).on('click', '.compact-mode .j-compact-row', function (e) {
    if ($(window).width() > 991) {
        return;
    }
    if ($(e.target).closest('button, a, input, select, label, .dropdown-menu, .btn-group').length) {
        return;
    }
    const tradeId = $(this).data('id');
    if (!tradeId) return;
    openCompactTradeDetails(tradeId);
});

$(document).on('click', '.j-reveal-masked', function (e) {
    e.stopPropagation();
    const $span = $(this);
    const full = $span.data('full');
    const masked = $span.data('masked') || $span.text();
    if ($span.data('revealed')) {
        $span.text(masked).data('revealed', false);
    } else {
        $span.data('masked', masked).text(full).data('revealed', true);
    }
});

$(document).on('click', '.j-cancel_withdraw', function (e) {
    e.preventDefault();

    const transactionId = $(this).data('transaction');
    const button = $(this);

    if (!transactionId) {
        return;
    }

    const token = $('meta[name="csrf-token"]').attr("content");

    button.prop('disabled', true);

    $.ajax({
        headers: {
            'X-CSRF-TOKEN': token
        },
        type: 'POST',
        url: `/transactions/${transactionId}/cancel`,
        dataType: 'json',
        success: function (msg) {
            if (msg['success'] === true) {
                $.bootstrapGrowl(msg['message'], { delay: 3000 });
                $.magnificPopup.close();
                setTimeout(function () {
                    window.location.reload();
                }, 350);
            } else {
                $.bootstrapGrowl(msg['message'], { delay: 3000 });
            }
        },
        error: function () {
            $.bootstrapGrowl(window.translations?.undefined_error, { delay: 3000 });
        },
        complete: function () {
            button.prop('disabled', false);
        }
    });
});


const themeAttr = "data-bs-theme";
const bodyElement = $("body")[0];
const themeButtons = $(".j-theme-toggle");
const formatTheme = (value) => value.charAt(0).toUpperCase() + value.slice(1);

const updateLogos = (theme) => {
    $(".j-theme-logo").each(function () {
        const el = $(this);
        const light = el.data("logoLight") || el.attr("src");
        const dark = el.data("logoDark") || light;
        const src = theme === "light" ? light : dark;
        if (src) {
            this.setAttribute("src", src);
        }
    });
};

const getThemeLabels = () => {
    const source = $(".j-theme-toggle").first();
    return {
        dark: source.data("themeDark") || formatTheme("dark"),
        light: source.data("themeLight") || formatTheme("light"),
    };
};

const updateThemeLabels = () => {
    const currentTheme = bodyElement.getAttribute(themeAttr) === "light" ? "light" : "dark";
    const nextTheme = currentTheme === "dark" ? "light" : "dark";
    const labels = getThemeLabels();

    $(".j-theme-state").text(labels[currentTheme]);
    $(".j-theme-next").text(labels[nextTheme]);
    themeButtons.attr("data-theme", currentTheme);
    updateLogos(currentTheme);
};

const persistThemeChoice = () => {
    const token = $('meta[name="csrf-token"]').attr('content');

    $.ajax({
        headers: { "X-CSRF-TOKEN": token },
        type: "POST",
        url: "/visualAction",
        data: { visual: "theme" },
        dataType: "json",
        success: function (msg) {
            if (!msg.success) {
                $.bootstrapGrowl(msg.message, {
                    type: "danger",
                    delay: 3000,
                });
            }
        },
        error: function () {
            $.bootstrapGrowl(window.translations?.undefined_error, {
                type: "danger",
                delay: 3000,
            });
        },
    });
};

themeButtons.on('click', () => {
    const currentTheme = bodyElement.getAttribute(themeAttr) === "light" ? "light" : "dark";
    const nextTheme = currentTheme === "dark" ? "light" : "dark";

    bodyElement.setAttribute(themeAttr, nextTheme);
    updateThemeLabels();
    persistThemeChoice();

    if (currentChartArgs) {
        loadChart(
            currentChartArgs.currency,
            currentChartArgs.type,
            currentChartArgs.precision,
            currentChartArgs.timeframe
        );
    }
});

// One-click trading
var ONE_CLICK_ENABLED_KEY = 'one_click_trading_enabled';
var ONE_CLICK_AMOUNT_KEY = 'one_click_trading_amount';

function getOneClickEnabled() {
    try { return localStorage.getItem(ONE_CLICK_ENABLED_KEY) === '1'; } catch(e) { return false; }
}

function getOneClickAmount() {
    try { return parseFloat(localStorage.getItem(ONE_CLICK_AMOUNT_KEY)) || 0; } catch(e) { return 0; }
}

function initOneClickTrading() {
    var $wrap = $('.j-one-click-wrap');
    if (!$wrap.length) return;

    var enabled = getOneClickEnabled();
    var amount = getOneClickAmount();

    $wrap.find('.j-one-click-toggle').prop('checked', enabled);

    if (enabled) {
        $wrap.find('.j-one-click-amount-row').show();
        var $amountInput = $wrap.find('.j-one-click-amount');
        if (amount > 0 && !$amountInput.is(':focus')) {
            $amountInput.val(amount.toFixed(2));
            $('[name="used_margin"]').val(amount.toFixed(2));
            try { handleCalculationTrigger({ target: { name: 'used_margin' } }); } catch(e) {}
        }
    } else {
        $wrap.find('.j-one-click-amount-row').hide();
    }
}

try { initOneClickTrading(); } catch(e) {}

$('body').on('change', '.j-one-click-toggle', function() {
    var enabled = $(this).is(':checked');
    try { localStorage.setItem(ONE_CLICK_ENABLED_KEY, enabled ? '1' : '0'); } catch(e) {}

    var $wrap = $(this).closest('.j-one-click-wrap');
    $wrap.find('.j-one-click-amount-row').toggle(enabled);

    if (enabled) {
        var amount = getOneClickAmount();
        if (amount > 0) {
            $('[name="used_margin"]').val(amount.toFixed(2));
            handleCalculationTrigger({ target: { name: 'used_margin' } });
        }
    }
});

$('body').on('keyup input', '.j-one-click-amount', function() {
    var amount = parseFloat($(this).val()) || 0;
    try { localStorage.setItem(ONE_CLICK_AMOUNT_KEY, String(amount)); } catch(e) {}
    if (amount > 0) {
        $('[name="used_margin"]').val(amount.toFixed(2));
        handleCalculationTrigger({ target: { name: 'used_margin' } });
    }
});

$('body').on('change', '[name="type_id"]', function() {
    if (!$('.j-one-click-wrap').length) return;
    if (!getOneClickEnabled()) return;

    var amount = getOneClickAmount();
    if (amount <= 0) return;

    // Defer to run after existing type_id handler (which calls resetTradeForm)
    setTimeout(function() {
        $('[name="used_margin"]').val(amount.toFixed(2));
        handleCalculationTrigger({ target: { name: "used_margin" } });

        // TODO: Remove if it has no impact. This is a weird piece of code, but I'm afraid to delete it
        // setTimeout(function() {
        //     var $btn = $('#trade button[type="submit"]');
        //     if (!$btn.is(':disabled')) {
        //         $btn.click();
        //     }
        // }, 50);
    }, 0);
});

$(document).on('click', '.j-tier_coin_btn', function () {
    $.get('/account-level-popup', function (html) {
        $('#tier_comparison_pop').html(html);
        $.magnificPopup.open({
            items: { src: '#tier_comparison_modal' },
            type: 'inline',
            closeOnBgClick: true,
            fixedContentPos: true,
            closeBtnInside: false,
            mainClass: 'my-mfp-zoom-in'
        });
    });
});

// ── Section hide / restore / reorder ─────────────────────────────────────────

let _sectionSortable = null;

function getSectionTabList() {
    return $('#trades .j-section-tabs');
}

function getSectionOrder() {
    const order = [];
    getSectionTabList().find('.j-section-item').each(function () {
        order.push($(this).data('section'));
    });
    return order;
}

function getHiddenSections() {
    const hidden = [];
    getSectionTabList().find('.j-section-item.d-none').each(function () {
        hidden.push($(this).data('section'));
    });
    return hidden;
}

function activateFirstVisibleSection() {
    const $tabs = getSectionTabList();
    const $activeTab = $tabs.find('.j-section-item:not(.d-none) .nav-link');
    if ($activeTab.length) {
        $activeTab.first().tab('show');
    }
}

function syncAddButton() {
    const $addItem = $('#trades .j-add-section-item');
    const hiddenCount = getHiddenSections().length;
    if (hiddenCount === 0) {
        $addItem.addClass('d-none');
    } else {
        $addItem.removeClass('d-none');
    }
}

function rebuildRestoreDropdown() {
    const $dropdown = $('#trades .j-restore-dropdown');
    $dropdown.empty();
    getSectionTabList().find('.j-section-item.d-none').each(function () {
        const key   = $(this).data('section');
        const $navLink = $(this).find('.nav-link');
        const label = $navLink.find('.section-label-short').first().text().trim()
            || $navLink.find('.section-label-full').first().text().trim();
        $dropdown.append(
            '<li><button class="section-restore-btn j-restore-section" type="button" data-section="' + key + '">' + label + '</button></li>'
        );
    });
}

function saveSectionSettings() {
    $.post('/saveSectionSettings', {
        order:  getSectionOrder(),
        hidden: getHiddenSections(),
        _token: $('meta[name="csrf-token"]').attr('content'),
    });
}

function hideSection(key) {
    const $tabs = getSectionTabList();
    const $item = $tabs.find('.j-section-item[data-section="' + key + '"]');
    const wasActive = $item.find('.nav-link').hasClass('active');

    $item.addClass('d-none');

    if (wasActive) {
        activateFirstVisibleSection();
    }

    rebuildRestoreDropdown();
    syncAddButton();
}

function restoreSection(key) {
    const $tabs     = getSectionTabList();
    const $item     = $tabs.find('.j-section-item[data-section="' + key + '"]');
    const hadActive = $tabs.find('.j-section-item:not(.d-none) .nav-link.active').length > 0;

    $item.removeClass('d-none');

    if (!hadActive) {
        $item.find('.nav-link').tab('show');
    }

    rebuildRestoreDropdown();
    syncAddButton();
}

function initSectionSortable() {
    if (_sectionSortable) {
        _sectionSortable.destroy();
        _sectionSortable = null;
    }

    const tabList = getSectionTabList().get(0);
    if (!tabList || typeof Sortable === 'undefined') {
        return;
    }

    _sectionSortable = Sortable.create(tabList, {
        handle:         '.nav-link',
        animation:      150,
        delay:          200,
        delayOnTouchOnly: true,
        onEnd: function (evt) {
            if (typeof evt.oldIndex === 'number' && typeof evt.newIndex === 'number' && evt.oldIndex === evt.newIndex) {
                return;
            }

            saveSectionSettings();
        },
    });
}

$(document).on('click', '.j-section-close', function (e) {
    e.preventDefault();
    e.stopPropagation();
    const key = $(this).data('section');
    hideSection(key);
    saveSectionSettings();
});

$(document).on('click', '.j-restore-section', function () {
    const key = $(this).data('section');
    restoreSection(key);
    saveSectionSettings();
});
